import brInvoices from '../views/invoices/language/brInvoices'
import brCategory from '../views/category/language/brCategory'
import brItem from '../views/item/language/brItem'
import brPriceTable from '../views/priceTable/language/brPriceTable'
import brItemPrice from '../views/itemPrice/language/brItemPrice'
import brSplit from '../views/split/language/brSplit'
import brQuote from '../views/quote/language/brQuote'
import brVendors from '../views/vendor/language/brVendors'
import brCharge from '../views/charge/language/brCharge'
import brHostRating from '../views/hostRating/language/brHostRating'
import brHausefulUsers from '../views/hausefulUsers/language/brHausefulUsers'
import brMapDrawing from '../views/mapDrawing/language/brMapDrawing'
import brImpersonate from "@/components/impersonate/language/brImpersonate"
import brServiceProviders from '../views/serviceProvider/language/brServiceProviders'
import brFinancialReport from '../views/financialReport/language/brFinancialReport'
import brDivergence from '../views/divergence/language/brDivergence'

const brGroup = {
  pages: {
    title: {
      map: 'Mapa',
      maps: 'Mapas',
      groupMap: 'Mapa de grupos',
      operationMap: 'Mapa de operações',
      customerList: 'Clientes',
      board: 'Painel de serviços',
      receivedInvoices: 'Notas fiscais recebidas',
      invoices: 'Notas fiscais',
      invoicesHosts: 'Notas fiscais Hosts',
      invoicesHauseful: 'Notas fiscais Hauseful',
      adminInvoicesHosts: 'Acompanhamento de notas fiscais dos hosts',
      missions: 'Missões',
      missionProgress: 'Progresso da missão',
      hosts: 'Hosts',
      cities: 'Cidades',
      appointmentList: 'Histórico de agendamentos',
      modelsInspections: 'Modelos de relatórios vinculados',
      appointmentDetails: 'Detalhes do agendamento',
      rechargeList: 'Recargas',
      chargeList: 'Cobranças',
      movementList: 'Extrato',
      realtyList: 'Imóveis',
      reports: 'Relatórios',
      error404: 'Página não encontrada',
      hausefulUsers: 'Usuários Hauseful',
      hostOnboarding: 'Host Onboarding',
      hostAppointmentsList: 'Serviços dos Hosts',
      users: 'Usuários',
      branches: 'Filiais',
      clients: 'Clientes',
      integration: 'Integrações',
      myPlan: 'Meu plano',
      RealEstateContractList: 'Contratos do cliente',
      contractDetails: 'Detalhes do contrato',
      transfers: 'Transferências',
      transferDetails: 'Detalhes da Transferência',
      categoryList: 'Categorias',
      itemList: 'Lista de itens',
      priceTable: 'Tabela de preços',
      vendorsList: 'Fornecedores',
      payments: 'Pagamentos',
      hostInvoices: 'Notas fiscais do Host',
      splitConfigurationList: 'Configurações de split',
      questionnaireList: 'Questionários',
      questionnaireQuestionsDetails: 'Perguntas do questionário',
      partners: 'Parceiros',
      announcements: 'Comunicados',
      RealEstateBranchList: 'Filiais do cliente',
      appointmentDashboard: 'Dashboard de agendamentos',
      rentOut: 'Rent Out',
      financial: 'Financeiro',
      serviceProviders: 'Prestadores de serviço',
      serviceProvider: 'Prestador de serviço',
      checkout: 'Checkout',
      auditList: 'Listagem de auditorias',
      disputeList: 'Listagem de revisões',
      divergenceList: 'Recálculos e reembolsos',
    },
  },
  genericFilters: {
    label: {
      city: 'Cidade',
      realEstate: 'Imobiliária',
      customer: 'Cliente',
      host: 'Host',
    },
    selectHour: {
      label: {
        hour: 'Hora',
        preferences: 'Preferenciais',
        other: 'Outros horários',
      },
    },
    orderBy: {
      ASC: 'Mais antigos',
      DESC: 'Mais recentes',
    },
  },
  realEstate: {
    title: {
      createNewBranch: 'Criar nova filial',
    },
    roles: {
      operator: 'Operador',
      surveyor: 'Vistoriador',
    },
    subscriptionTypes: {
      TRIAL: 'Trial',
      SINGLE_PURCHASE: 'Avulso',
      PREPAID: 'Pré pago',
      PREPAID_SAAS: 'Pré pago SAAS',
      POSTPAID: 'Pós pago',
      POSTPAID_SAAS: 'Pós pago SAAS',
      SUBSCRIPTION_TRIMESTER: '3 meses',
      SUBSCRIPTION_SEMESTER: '6 meses',
      SUBSCRIPTION_NONAMESTER: '9 meses',
      SUBSCRIPTION_YEAR: '12 meses',
      SUBSCRIPTION_LIFELONG: 'Vitálicio',
    },
    actions: {
      create: 'Nova filial',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      save: 'Salvar',
    },
  },
  announcement: {
    modals: {
      confirmDelete: {
        title: 'Remover comunicado',
        text: 'Tem certeza que deseja excluir o comunicado?',
        buttons: {
          cancel: 'Cancelar',
          confirm: 'Confirmar',
        },
      },
    },
    label: {
      messages: {
        successCreation: 'Comunicado criado com sucesso',
        successDelete: 'Comunicado excluído com sucesso',
      },
      summary: {
        title: 'Titulo',
        content: 'Mensagem',
        services: 'Serviços',
        cities: 'Cidades',
        hosts: 'Hosts',
        send: 'Envio',
        type: 'Tipo',
        immediately: 'Imediatamente',
        survey: 'Vistoria',
      },
      create: {
        announcementType: 'Tipo de destinatário',
        serviceType: 'Tipos de serviço',
        cities: 'Cidades',
        hosts: 'Hosts',
        message: 'Mensagem',
        sendType: 'Tipo de envio',
        releaseDate: 'Data de envio',
        title: 'Título',
        selectHosts: 'Selecionar hosts',
        validation: {
          content: 'Comunicado não pode estar vazio',
        },
        announcementTypes: {
          ALL: 'Todos',
          HOST: 'Hosts',
          CUSTOMER: 'Clientes',
          undefined: '---',
        },
        sendTypes: {
          immediately: 'Imediato',
          scheduled: 'Agendado',
        },
      },
      list: {
        createdAt: 'Criado em',
        releaseDate: 'Data de envio',
        releaseDateImmediately: 'Imediato',
        type: 'Enviar para',
        title: 'Título',
        announcementTypes: {
          HOST: 'Hosts',
          CUSTOMER: 'Clientes',
          ALL: 'Todos',
        },
        actions: {
          details: 'Detalhes',
          delete: 'Desativar',
        },
      },
    },
    actions: {
      details: 'Mostrar detalhes',
      delete: 'Remover comunicado',
      duplicate: 'Duplicar comunicado',
    },
  },
  transfer: {
    label: {
      name: 'Nome',
      host: 'Host',
      createdAt: 'Criado em',
      status: 'Status',
      receiver: 'Destinatário',
      asaasTransferId: 'ID da transferência (Asaas)',
      total: 'Total',
      visualize: 'Visualizar transferência',
      retryTransfer: 'Tentar lançar novamente',
      transferToSelected: 'Transferir para selecionados',
      confirmTransfer: 'Confirmar transferência',
      executeTransfer: 'Executar transferência',
      generateReport: 'Gerar excel',
      transferReport: 'Relatório de transferências',
      appointment: 'Agendamento',
    },
    transferStatus: {
      CANCELED: 'Cancelada',
      FAILED: 'Falhou',
      PENDING: 'Pendente',
      PROCESSING: 'Processando',
      COMPLETED: 'Completo',
      CALCULATED: 'Calculada',
      CUSTOM: 'Customizada',
      CHARGEBACK: 'Estorno',
      DETACHED: 'Avulso',
    },
    noData: 'Aplique um filtro para listar as transferências',
    orderBy: {
      ASC: 'A-Z',
      DESC: 'Z-A',
    },
    filter: {
      host: 'Nome do host',
      vendor: 'Nome do fornecedor',
      partner: 'Nome do parceiro',
      nameForReceiver:'Nome do Responsável',
      date: 'Período',
      status: 'Status',
      orderBy: 'Ordenar',
      receiverType: 'Tipo de destinatário',
    },
    receiverType: {
      HOST: 'Host',
      VENDOR: 'Fornecedor',
      PARTNER: 'Parceiro',
    },
    details: {
      transferData: 'Dados da transferência',
      status: 'Status',
      total: 'Total',
      createdAt: 'Criado em',
      updatedAt: 'Atualizado em',
      asaasId: 'Id da transferência (Asaas)',
      appointment: 'Agendamento',
      receiver: 'Destinatário',
      invoices: 'Notas fiscais',
      payments: {
        type: 'Tipo',
        total: 'Total',
        label: 'Pagamentos',
        details: 'Detalhes',
        appointmentCode: 'Cód. do agendamento',
        appointmentDate: 'Data do agendamento',
        createdAt: 'Data do Pagamento',
        description: 'Descrição',
      },
      types: {
        mission: 'Missão',
        appointment: 'Agendamento',
        detached: 'Avulso',
      },
      history: {
        label: 'Histórico de transferência',
        createdAt: 'Criado em',
        status: 'Status',
        description: 'Descrição',
      },
    },
    hint: {
      wantToTransfer: 'Deseja transferir os valores para os seguintes destinatários?',
      successMessage: 'Transferência(s) adicionada(s) a fila com sucesso!',
    },
  },
  onboarding: {
    register: {
      title: 'Olá! Crie uma conta para continuar',
      name: 'Nome',
      customerName: 'Nome da empresa',
      email: 'E-mail',
      phone: 'Telefone',
      password: 'Senha',
      repeatPassword: 'Repita a senha',
      cpf: 'CPF',
      cnpj: 'CNPJ',
      cpfCnpj: 'CPF/CNPJ',
      accountType: {
        business: 'Empresa ou MEI',
        individual: 'Pessoa Física',
        error: 'Escolha uma opção',
      },
      creationAccept: 'Ao criar sua conta, você concorda com os nossos',
      createTerms: 'Termos de Uso',
      createAccount: 'Criar conta',
      alreadyHaveAccount: 'Já possuo conta',
      isFurnished: 'Possui mobília?',
      isTrousseau: 'Possui enxoval?',
      yes: 'Sim',
      no: 'Não',
      errors: {
        phone: 'Telefone inválido',
        mail: 'E-mail inválido',
        minimum: 'Precisa ser maior',
        cpf: 'CPF inválido',
        cnpj: 'CNPJ inválido',
        passwordMismatch: 'Senhas não são iguais',
      },
    },
    address: {
      title: 'Qual o endereço da sua empresa?',
      form: {
        address: 'Endereço com número',
        addressHint: 'Digite o endereço com rua e número válidos',
        addressNumber: 'Número',
        addressNumberHint: 'Identificaremos o número com base no endereço',
        zipCode: 'CEP',
        zipCodeHint: 'Identificaremos o CEP com base no endereço',
      },
    },
    services: {
      title: 'Escolha o serviço que você quer solicitar agora, mais tarde você poderá solicitar outros',
    },
    plans: {
      title: 'Escolha entre serviço avulsos e planos recorrentes com descontos!',
      single: {
        title: 'Serviço Avulso',
        description: 'Contratação imediata',
      },
      recurrent: {
        title: 'Planos de 3, 6 e 12 meses',
        description: 'Nossa equipe entrará em contato',
      },
    },
    details: {
      title: 'Detalhes do imóvel',
      description: 'Preencha com cuidado o campo de área privativa. Ela será utilizada para calcular o valor do serviço.',
    },
    contract: {
      title: 'Contrato',
      acceptAndGoToPayment: 'Aceitar contrato e ir para o pagamento',
    },
    payment: {
      titleSelect: 'Quase lá! Selecione o método de pagamento',
      description: 'Preencha suas informações para pagamento',
      amount: 'Valor',
      amountDescription: 'Valor gerado de acordo com o serviço e a metragem indicada.',
      with: 'Pague com',
      pix: {
        title: 'PIX',
        withPix: 'Pague com PIX',
        description: 'Use o leitor de seu celular ou copie e cole o código PIX para efetuar o pagamento',
        status: {
          PENDING: 'Aguarde alguns minutos nesta tela até que o pagamento seja confirmado',
        },
      },
      creditCard: {
        title: 'Cartão de Crédito',
        withCreditCard: 'Pague com Cartão de Crédito',
        description: 'Preencha com os dados de seu cartão de crédito',
      },
    },
    card: {
      name: 'Nome',
      nameHint: 'Digite o nome do titular do cartão',
      number: 'Número do Cartão',
      numberHint: 'Apenas os números',
      dueDate: 'Data de Vencimento',
      dueDateHint: 'MM/AAAA',
      ccv: 'CVC',
      ccvHint: 'Ex.: 123',
    },
    noRecurringPayment: {
      titleFine: 'Tudo certo,',
      titleWithUs: 'agora é com a gente!',
    },
    success: {
      createAppointment: 'Agendar serviço',
      createAnotherTime: 'Agendar depois',
      thanksMessage: 'Sua conta está ativa',
      confirmationMessage: 'A Hauseful já confirmou todos os seus dados. Sua conta está disponível com os créditos adquiridos. Vamos agendar o serviço?',
    },
    actions: {
      next: 'Próximo',
      previous: 'Anterior',
      addCredit: 'Confirmar pagamento',
      chooseAnotherCity: 'Escolha outra cidade',
    },
    options: {
      furnished: 'Mobiliado',
      noFurnished: 'Sem mobilia',
      trousseau: 'Possui enxoval',
      noTrousseau: 'Sem enxoval',
    },
  },
  emptyState: {
    noData: 'Nenhum item para apresentar',
    noDataDoTheSearch: 'Faça a busca para encontrar o item desejado',
  },
  dashboard: {
    alert: {
      type: {
        IN_TIME_CANCELLATION: 'Cancelamento em cima da hora',
        OVERPRICED_APPOINTMENT: 'Agendamento com valor alto',
        INACTIVE_CUSTOMER: 'Cliente inativo',
        SCHEDULING_DECREASE: 'Queda no número de agendamentos',
      },
      label: {
        description: 'Descreva a solução',
      },
      button: {
        moreInformation: 'Mais informações',
        solved: 'Marcar como resolvido',
      },
      card: {
        description: 'Descrição do alerta',
        solutionDescription: 'Descrição da Solução',
        date: 'Data',
        client: 'Cliente',
        code: 'Código',
      },
      popup: {
        confirmation: 'Deseja encerrar o alerta ?',
        yes: 'Sim',
        no: 'Não',
      },
      errors: {
        requiredSolution: 'É necessário descrever a solução.',
        minimumCharacters: 'Mínimo de 10 caracteres.',
        maximumCharacters: 'Máximo de 500 caracteres.',
      },
    },
    cardAppointment: {
      scheduling: 'Agendamento',
      reschedule: 'Reagendamentos',
      numberOfReschedules: 'reagendamento(s)',
      realty: 'Imóvel',
      user: 'Usuário',
      realtyCode: 'Código do imóvel',
      phone: 'Telefone',
      host: 'Host',
      name: 'Nome',
      realties: 'Imóveis',
      document: 'CPF/CNPJ',
      documentForUser: 'CPF/CNPJ do Responsável',
      observation: 'Observação',
      withoutObservation: 'Sem observação',
      meetingAddress: 'Local de encontro',
      needsAuthorization: 'Necessita autorização',
      scheduledBy: 'Agendado por',
      visitor: 'Visitante',
      cpf: 'CPF',
      birthDate: 'Data de nascimento',
      tenant: 'Inquilino/acompanhante',
      date: 'Data',
      address: 'Endereço',
      totalArea: 'Área total',
      privateArea: 'Área privativa',
      furnished: 'Mobília',
      trousseau: 'Enxoval',
      btnClose: 'Fechar',
      loading: 'Carregando...',
      displacement: 'Deslocamento',
      client: 'Cliente',
      additionalData: 'Informações adicionais',
      observations: 'Observações',
      confirmationTitle: 'Confirmação',
      displaceAndAuthorization: 'Deslocamento e autorização',
      additionalAddressData: 'Complemento',
      scheduledDifference: {
        in: 'em',
        hour: 'hora(s)',
        minutes: 'minuto(s)',
        lessThanMinute: 'menos de 1 minuto',
      },
      yes: 'Sim',
      no: 'Não',
      painting: {
        label: 'Pintura',
        NEW: 'Nova',
        WORN: 'Desgastada',
        HOST_CRITERIA: 'Crit. do Host',
      },
      moreDetails: 'Mais detalhes',
      confirmation: {
        confirmed: 'Confirmado?',
        attendingToAppointment: 'Comparecerá ao agendamento?',
        keysNeedsAuthorization: 'Chaves precisam de autorização?',
        observations: 'Observações',
        notAnsweredYet: 'A confirmação ainda não foi respondida',
        sentAt: 'Enviado em',
        acceptedDate: 'Data combinada',
        answeredAt: 'Respondido em',
      },
    },
    tabFilter: {
      menu: {
        filter: 'Filtro',
        result: 'Resultado',
      },
      button: {
        applyFilters: 'Aplicar filtros',
        clear: 'Limpar',
        hostRoutes: 'Rotas Host',
      },
      label: {
        status: 'Status',
        cities: 'Cidades',
        serviceType: 'Tipo de serviço',
        clients: 'Clientes',
        hosts: 'Hosts',
        until: 'Até',
        search: 'Buscar por código ou imóvel',
        country: 'País',
      },
      tableHeaders: {
        date: 'Data',
        status: 'Status',
        type: 'Tipo',
        info: 'Info',
      },
    },
    navigationPeriod: {
      button: {
        today: 'Hoje',
        tomorrow: 'Amanhã',
        week: 'Semana',
      },
    },
    notificationsPage: {
      alerts: {
        title: 'Alertas',
        success: 'SUCESSO',
        successfullyMarkedAsResolved: 'Marcado como resolvido com sucesso.',
        info: 'INFORMAÇÃO',
        infoMessage: '',
        warning: 'AVISO',
        warningMessage: '',
        danger: 'PERIGO',
        dangerMessage: '',
      },
    },
    useTheSearch: 'Busque o item desejado para aplicar o filtro',
  },
  devolus: {
    pendingActions: 'Devolus: Ações pendentes',
    table: {
      date: 'Data',
      type: 'Tipo',
      resolution: 'Resolução',
      info: 'Info',
    },
    labels: {
      host: 'Host',
      date: 'Data',
      appointmentDate: 'Data do agendamento',
      observations: 'Observações',
      address: 'Endereço',
      solve: 'Resolver',
      solved: 'Resolvido',
      solvedDate: 'Data de resolução',
      devolusHistory: 'Histórico Devolus',
      moreDetails: 'Mais detalhes',
      createdAt: 'Criado em',
      eventDate: 'Data do evento',
      errorMessage: 'Mensagem de erro',
      user: 'Usuário',
      keyPicker: 'Responsável pela chave',
      keyLocation: 'Retirada da chave',
      keyAddress: 'Endereço da chave',
      createdBy: 'Criado por',
      filters: 'Filtros',
      resolved: 'Ações Devolus resolvidas',
      notResolved: 'Ações Devolus não resolvidas',
    },
    errors: {
      ERROR_REALTY: 'Erro com imóvel',
      ERROR_USER: 'Erro com usuário',
      ERROR_REAL_ESTATE: 'Erro com imóvel',
      ERROR_APPOINTMENT: 'Erro com agendamento',
      ERROR_INTEGRATION: 'Erro com a integração',
      ERROR_ATTACHMENT: 'Erro com anexo',
    },
    modals: {
      appointmentDetails: {
        title: 'Detalhes do agendamento',
      },
    },
  },
  board: {
    host: 'Host',
    visitor: 'Visitante',
    tenant: 'Inquilino/Acompanhante',
    openColumnInfo: 'Serviços em oferta aos hosts',
    scheduledColumnInfo: 'Serviços aceitos, pendentes de execução ou em andamento',
    canceledColumnInfo: 'Agendamentos cancelados',
    doneColumnInfo: 'Serviços finalizados',
    outputs: 'Entregáveis',
    realties: 'Imóveis',
    columnInfo: {
      OPEN: 'Serviços em oferta aos hosts',
      SCHEDULED: 'Serviços aceitos, pendentes de execução ou em andamento',
      CANCELED: 'Agendamentos cancelados',
      DONE: 'Serviços finalizados',
    },
    badges: {
      hasStarted: 'Em Andamento',
      canceledByHost: 'Host cancelou',
      notConfirmed: 'Não confirmado',
    },
    actions: {
      reschedule: 'Reagendar',
      visualize: 'Visualizar',
      cancel: 'Cancelar',
      editVisitor: 'Editar visitante',
      editTenant: 'Editar inquilino',
      dispute: 'Visualizar relatório',
    },
    emptyState: {
      title: 'Clique aqui para agendar o seu primeiro serviço',
      createAppointment: 'Agendar serviço',
    },
    card: {
      urgent: 'URGENTE',
    },
  },
  integration: {
    list: 'Listagem de integrações',
    buttons: {
      add: 'Adicionar Integração',
      update: 'Editar Integração',
      save: 'Salvar',
    },
    externalSources: {
      VISTA: 'Vista',
      BROGNOLI: 'Brognoli',
    },
    label: {
      externalSource: 'Fonte',
      apiUrl: 'URL',
      keyCode: 'Chave',
      status: 'Status',
      apiUser: 'Usuário',
      active: 'Ativa',
      inactive: 'Inativa',
      pushEnabled: 'Enviar imóveis para a Loft',
    },
    hint: {
      pushEnabled: 'Com a opção ligada, imóveis criados, editados e excluídos no Hauseful passam a ser refletidos na Loft.',
    },
    warnings: {
      pushEnabled: 'A partir daí as alterações saem do Hauseful para a base real da imobiliária na Loft, incluindo as exclusões, que são definitivas lá.',
    },
    rules: {
      required: 'Campo obrigatório',
      apiUrl: "Url inválida (verifique se está incluindo 'http' ou 'https' e '/' ao final)",
    },
    toaster: {
      success: {
        updated: 'Integração atualizada com sucesso!',
        created: 'Integração criada com sucesso!',
      },
    },
    table: {
      loading: 'Carregando... Por favor aguarde',
      noData: 'Sem resultados',
    },
  },
  hostAppointments: {
    headers: {
      host: 'Host',
      servicesQuantity: 'Quantidade de serviços',
      totalValue: 'Valor total',
      squareMetersTotal: 'Metragem total',
    },
    label: {
      services: 'Tipos de serviços realizados',
      host: 'Host',
      servicesQuantity: 'Quantidade de serviços',
      totalValue: 'Valor total',
      squareMetersTotal: 'Metragem total',
    },
  },
  contract: {
    noData: 'Sem resultados',
    creationSuccessMessage: 'Contrato criado com sucesso!',
    realEstateHasNoActiveContract: 'Imobiliária não possui contrato ativo',
    label: {
      subscriptionTypes: {
        TRIAL: 'Trial',
        PREPAID: 'Pré pago',
        PREPAID_SAAS: 'Pré pago SAAS',
        POSTPAID: 'Pós pago',
        POSTPAID_SAAS: 'Pós pago SAAS',
        SINGLE_PURCHASE: 'Avulso',
        SUBSCRIPTION_TRIMESTER: '3 meses',
        SUBSCRIPTION_SEMESTER: '6 meses',
        SUBSCRIPTION_NONAMESTER: '9 meses',
        SUBSCRIPTION_YEAR: '12 meses',
        SUBSCRIPTION_LIFELONG: 'Vitálicio',
      },
      isActive: {
        true: 'Ativo',
        false: 'Inativo',
      },
      monthlyAmount: 'Valor mensal (Capacidade)',
      monthlyCapacity: 'Volume mensal (Capacidade)',
      dailyCapacity: 'Valor diário (Capacidade)',
      overuseFee: 'Valor por vistoria excedente (R$)',
      overuseFeePlaceholder: 'Vazio não cobra excedente',
      startDate: 'Data de início',
      endDate: 'Data de expiração',
      validity: 'Vigência',
      contractType: 'Tipo de contrato',
      realEstate: 'Imobiliária',
      date_created: 'Data de criação',
      createdBy: 'Criado por',
      type: 'Plano',
      is_active: 'Status',
      details: 'Detalhes de Contrato',
      serviceType: 'Tipo de serviço',
      price: 'Preço',
      discount: 'Desconto',
      squareMetersPrice: 'Preço por m²',
      baseSquareMetersPrice: 'Tamanho base m²',
      taxHost: 'Taxa Host',
      displacementTax: 'Taxa de deslocamento',
      taxSquareMeters: 'Taxa por m²',
      furnitureTax: 'Taxa de mobília',
      semiFurnitureTax: 'Taxa de semimobiliado',
      houseTax: 'Taxa de casa',
      trousseauTax: 'Taxa de enxoval',
      urgencyTax: 'Taxa de urgência',
      hostUrgencyTax: 'Taxa do Host sob urgência',
      urgencyHoursLimit: 'Limite de urgência (horas)',
      hostRealtyFeatureTax: 'Taxa do host sob características do imóvel',
      values: 'Valores',
    },
    details: {
      services: 'Serviços',
      price: 'Preço',
      hostTax: 'Taxa Host',
      discount: 'Desconto',
      squareMetersPrice: 'Preço metro área privativa',
      squareMetersTax: 'Taxa do metro da área privativa',
      baseSquareMetersPrice: 'Tamanho base de cálculo',
      furnitureTax: 'Taxa de mobília',
      semiFurnitureTax: 'Taxa de semimobiliado',
      houseTax: 'Taxa de casa',
      trousseauTax: 'Taxa de enxoval',
      displacementTax: 'Taxa de deslocamento',
      hostRealtyFeatureTax: 'Taxa do host sob características do imóvel',
      urgencyTax: 'Taxa de urgência',
      hostUrgencyTax: 'Taxa do Host sob urgência',
      urgencyHoursLimit: 'Limite de urgência (horas)',
    },
    actions: {
      next: 'Próximo',
      back: 'Voltar',
      addServiceContract: 'Adicionar serviço',
      addContract: 'Adicionar contrato',
      addcontractService: 'Adicionar contrato - Serviços',
      editServiceContract: 'Editar serviço',
      addService: 'Adicionar',
      editService: 'Atualizar',
      createContract: 'Criar contrato',
      copyContract: 'Copiar contrato',
      details: 'Detalhes',
    },
  },
  appointment: {
    divergenceType: {
      AREA: 'Metragem incorreta',
      FURNITURE: 'Mobília',
      TROUSSEAU: 'Enxoval',
      DISPLACEMENT: 'Deslocamento',
    },
    label: {
      appointmentCode: 'Cód. Agendamento',
      code: 'Código',
      realtiesCode: 'Código imóveis',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      type: 'Tipo',
      origin: 'Origem',
      status: 'Status',
      files: 'Arquivos',
      terminationTerms: 'Termos da rescisão',
      terminationTerm: 'Termo da rescisão',
      signedTerm: 'Assinado',
      notSignedTerm: 'Não assinado',
      outputs: 'Arquivos de resultado de agendamento',
      reason: 'Motivo',
      cancelled: 'Cancelado',
      date: 'Data de agendamento',
      dateLean: 'Data',
      description: 'Descrição',
      cancelDate: 'Data de cancelamento',
      cancellation: 'Cancelamento',
      divergenceRecalculation: 'Recálculo por divergência',
      divergenceTypes: 'Divergências confirmadas',
      divergenceContestDeadline: 'Prazo para reclamar',
      divergenceContestNoDeadline: 'Sem prazo definido',
      divergenceContestExpired: 'O prazo para reclamar deste recálculo já passou.',
      deleteFile: 'Excluir arquivo',
      deleteAllFiles: 'Excluir todos os arquivos',
      deleteSelectedFiles: 'Excluir os arquivos selecionados',
      hostData: 'Dados do host',
      hostName: 'Host',
      hostPhone: 'Telefone',
      hostMail: 'E-mail',
      hostRg: 'RG',
      externalCode: 'Código externo',
      cancellationOrigin: 'Motivo de cancelamento',
      cancelReason: 'Descrição do cancelamento',
      displacement: 'Deslocamento',
      operator: 'Operador',
      authorization: 'Autorização',
      download: 'Baixar',
      replace: 'Substituir',
      showOnClickSign: 'Visualizar no Clicksign',
      showClickSignSignatures: 'Visualizar signatários',
      branch: 'Filial',
      needsAuthorization: {
        question: 'Precisa de autorização?',
        yes: 'Sim',
        no: 'Não',
      },
      realEstate: 'Imobiliária',
      scheduledBy: {
        name: 'Organizador',
        phone: 'Telefone do organizador',
      },
      realties: 'Imóveis',
      realtyCode: 'Código',
      realtyCodes: 'Códigos dos imóveis',
      realtyAddress: 'Endereço',
      realtyAddressAdditional: 'Complemento',
      realtyDescription: 'Descrição',
      meetingLocation: 'Local de encontro',
      meetingLocationDescription: 'Endereço de encontro',
      observations: 'Observações',
      additionalValue: 'Valor adicional',
      hostValue: 'Valor host',
      keyPicker: 'Retirada da chave',
      keyLocation: 'Local de retirada de chave',
      keyLocationDescription: 'Endereço da chave',
      visitorData: 'Dados do visitante',
      tenantData: 'Dados do inquilino/acompanhante',
      visitorName: 'Nome',
      visitorPhone: 'Telefone',
      visitorMail: 'E-mail',
      today: 'Hoje',
      selectedRealty: 'Imóvel selecionado:',
      selectedRealties: 'Imóveis selecionados:',
      privateArea: 'Área privativa',
      totalArea: 'Área total',
      squareMetersSymbol: 'm²',
      fci: 'FCI',
      downloadAdditive: 'Baixar aditivo',
      serviceStatus: 'Status do serviço',
      updateFci: 'Editar FCI',
      value: 'Valor',
      yes: 'Sim',
      no: 'Não',
      slotSize: 'Duração',
      confirmation: {
        confirmed: 'Confirmado',
        rejected: 'Rejeitado',
        emailSent: 'Email de confirmação enviado',
        emailNotSent: 'Email de confirmação não enviado',
        keysNeedsAuthorization: 'Chaves precisam de autorização',
        keysDoesNotNeedAuthorization: 'Chaves não precisam de autorização',
        attendingToAppointment: 'Comparecerá ao agendamento',
        notAttendingToAppointment: 'Não comparecerá ao agendamento',
        notAnsweredYet: 'Ainda não foi respondido'
      },
      addToGroup: {
        title: 'Adicionar agendamentos ao grupo',
        message: 'Selecione o grupo para adicionar os agendamentos.',
        addThisAppointmentsToGroup: 'Adicionar os agendamentos selecionados ao grupo',
        add: 'Adicionar agendamento(s)',
        cancel: 'Cancelar',
      },
      workerType: 'Tipo de trabalhador',
    },
    statusTable: {
      details: 'Detalhes',
      code: 'Código',
      isServiceDone: 'Realizado?',
      comment: 'Comentário',
      address: 'Endereço',
      reasonNotPerformed: 'Motivo da não realização',
      billable: 'Faturável?',
      reopen: 'Reaberto?',
      photos: 'Fotos',
      type: 'Tipo',
      realized: {
        true: 'Realizado',
        false: 'Não realizado',
      },
      reasonType: {
        HOST: 'Host',
        CUSTOMER: 'Cliente',
        THIRD_PARTY: 'Outro',
      },
    },
    buttons: {
      add: 'Adicionar Agendamento',
      deleteAll: 'Excluir todos',
      deleteSelected: 'Excluir selecionados',
      moreDetails: 'Mais detalhes',
      showSummary: 'Resumo',
      generateExcel: 'Gerar Excel',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
    adminExcel: {
      fileName: 'Agendamentos',
    },
    needsAuthorizationInfo: 'Caso precise de autorização especifique e deixe ela pronta para uso do host',
    cancellationOrigin: {
      BY_HOST_NOT_HAPPENED: 'Não aconteceu',
      BY_HOST_NOT_GOING: 'Host desistiu',
      BY_REAL_ESTATE: 'Pela imobiliária',
      BY_REAL_ESTATE_EXPIRATION: 'Tempo de expiração',
      BY_ADMIN: 'Pelo administrador',
      BY_CS: 'Pelo suporte',
    },
    meetingLocation: {
      REAL_ESTATE: 'Filial',
      REALTY: 'Imóvel',
      OTHER: 'Outro',
    },
    keyPicker: {
      HOST: 'Host',
      VISITOR: 'Visitante',
      NOT_NEEDED: 'Não é necessário',
      undefined: '---',
    },
    keyLocation: {
      REAL_ESTATE: 'Filial',
      REALTY: 'Imóvel',
      SMART_BOX: 'SmartBox',
      OWNER: 'Dono do Imóvel',
      OTHER: 'Outro',
    },
    filters: {
      noData: 'Sem resultados',
      typeToSearchRealEstate: 'Digite para buscar clientes',
      status: 'Status',
      type: 'Tipo',
      sort: 'Ordenar',
      branch: 'Filial',
      search: 'Buscar',
      period: 'Período',
      cities: 'Cidades',
      hosts: 'Hosts',
      selectDate: 'Selecione uma data',
      subscriptionType: 'Plano',
      sortBy: {
        ASC: 'Mais antigos',
        DESC: 'Mais recentes',
      },
      buttons: {
        reset: 'Limpar',
        applyFilters: 'Aplicar filtros',
      },
      datePicker: {
        selectedItems: '2 selecionados',
      },
      confirmed: 'Confirmado',
      notConfirmed: 'Não confirmado',
      confirmationEmailSent: 'Email de confirmação foi enviado?',
      sent: 'Enviado',
      notSent: 'Não enviado',
      workerType: 'Tipo de trabalhador',
    },
    table: {
      loading: 'Carregando... Por favor aguarde',
      noData: 'Sem resultados',
      showExtraFields: 'Mostrar campos extras',
    },
    status: {
      OPEN: 'Aguardando Host',
      SCHEDULED: 'Agendado',
      DONE: 'Realizado',
      CANCELED: 'Cancelado',
      DRAFT: 'Rascunho',
      REJECTED: 'Rejeitado',
      PARTNER_OPEN: 'Em aberto',
      ACCEPTED: 'Aceito',
      undefined: '---',
    },
    partnerStatus: {
      DRAFT: 'Rascunho',
      REJECTED: 'Rejeitado',
      OPEN: 'Em aberto',
    },
    type: {
      VISIT: 'Visita',
      VISIT_PREMIUM: 'Visita Premium',
      PHOTOGRAPHY: 'Fotografia',
      PHOTOGRAPHY_PREMIUM: 'Fotografia Premium',
      PHOTOGRAPHY_360: 'Fotografia 360°',
      KEY_DELIVERY: 'Entrega de Chaves',
      INSPECTION: 'Vistoria de Entrada Gold',
      DISPLACEMENT: 'Deslocamento',
      DRONE: 'Drone',
      LOFT_VISIT: 'Visita Loft',
      INSPECTION_ENTRANCE: 'Vistoria de Entrada',
      INSPECTION_ENTRANCE_PREMIUM: 'Vistoria de Entrada Premium',
      INSPECTION_EXIT: 'Vistoria de Saída',
      INSPECTION_EXIT_GOLD: 'Vistoria de Saída Gold',
      INSPECTION_EXIT_PREMIUM: 'Vistoria de Saída Premium',
      INSPECTION_INTERMEDIARY: 'Vistoria Intermediária de Obra',
      INSPECTION_DELIVERY: 'Vistoria de Entrega de Obra',
      INSPECTION_MEASUREMENT: 'Vistoria de Medição',
      INSPECTION_AUDITANCE: 'Auditoria de Vistoria',
      REINSPECTION: 'Revistoria',
      REINSPECTION_HAUSEFUL: 'Revistoria Hauseful',
      TECHNICAL_SKETCH: 'Levantamento 2D Premium',
      TECHNICAL_SKETCH_PLUS: 'Levantamento 2D Plus',
      PLANNING: 'Projetos',
      IMAGE_EDITING: 'Edição de Imagens',
      REALTY_SUGGESTION: 'Sugestão de Imóvel',
      REMOTE_VISIT: 'Visita Remota',
      SKETCH: 'Levantamento 3D',
      INSPECTION_ENTRANCE_PLUS: 'Vistoria de Entrada Plus',
      INSPECTION_EXIT_PLUS: 'Vistoria de Saída Plus',
      INSPECTION_MINI: 'Vistoria Mini de Entrada',
      VISIT_GOLD: 'Visita de Entrada Gold',
      INSPECTION_CONSTRUCTION_INTERMEDIARY: 'Fiscalização de Obra - Intermediária',
      INSPECTION_CONSTRUCTION_FINAL: 'Fiscalização de Obra - Final',
      INSPECTION_CONFERRING_ENTRANCE: 'Vistoria de Entrada - Conferência',
      INSPECTION_ENTRANCE_HOUSEVIEW: 'Vistoria de Entrada - Houseview',
      INSPECTION_EXIT_HOUSEVIEW: 'Vistoria de Saída - Houseview',
      MAPPING_FOR_EVALUATION: 'Mapeamento de Informações',
      TERMINATION: 'Rescisão',
      RENT_OUT: 'Rescisão Facilitada',
      RENT_OUT_DUDA: 'Rescisão Facilitada - Duda Imóveis',
      DELIVERY: 'Delivery',
      INSPECTION_POST_INSTALLATION: 'Vistoria de Instalações',
      INSPECTION_AND_ESTIMATE: 'Vistoria + Orçamento',
      INSPECTION_SHED: 'Vistoria de Galpão - Entrada',
      INSPECTION_SHED_EXIT: 'Vistoria de Galpão - Saída',
      INSPECTION_IMOBMIX_ENTRANCE: 'Vistoria IMOBMIX de Entrada',
      INSPECTION_IMOBMIX_EXIT: 'Vistoria IMOBMIX de Saída',
      PHOTOGRAPHY_PLUS: 'Fotografia Plus',
      PHOTOGRAPHY_HAUSEFUL: 'Fotografia Hauseful',
      PHOTOGRAPHY_HOME_STAGING: 'Fotografia Gold',
      VISIT_AND_PHOTOS: 'Visita + Fotografia',
      VISIT_LIGHT: 'Visita Light',
      VISIT_SALE: 'Visita de Venda',
      TRAINING: 'Treinamento Prático',
      MISSION: 'Missões',
      PHOTOGRAPHY_PREMIUM_PLUS_360: 'Fotografia Plus + 360',
      OBSERVED_TRAINING: 'Treinamento Observado',
      DUMP: 'Constatação de Abandono',
      EVICTION: 'Visto - Chaves',
      INSPECTION_TEST: 'Vistoria de teste',
      INSPECTION_IB_ENTRANCE: 'Vistoria IB de Entrada',
      INSPECTION_IB_EXIT: 'Vistoria IB de Saída',
      INSPECTION_MINI_EXIT: 'Vistoria Mini de Saída',
      INSPECTION_MINI_EXIT_GOLD: 'Vistoria Mini de Saída Gold',
      INSPECTION_MINI_EXIT_PLUS: 'Vistoria Mini de Saída Plus',
      INSPECTION_MINI_ENTRANCE_GOLD: 'Vistoria Mini de Entrada Gold',
      INSPECTION_MINI_ENTRANCE_PLUS: 'Vistoria Mini de Entrada Plus',
      INSPECTION_ENTRANCE_BACKLOG: 'Vistoria de Entrada - Backlog',
      INSPECTION_EXIT_BACKLOG: 'Vistoria de Saída - Backlog',
      INSPECTION_ENTRANCE_ANTICIPATION: 'Vistoria de Entrada - Antecipação',
      INSPECTION_INSURER: 'Vistoria de Constatação - Seguradoras',
      LEASED_PROPERTY_CONFERENCE_ENTRANCE: 'Conferência de bens locados - Entrada',
      LEASED_PROPERTY_CONFERENCE_INTERMEDIARY: 'Conferência de bens locados - Intermediária',
      LEASED_PROPERTY_CONFERENCE_EXIT: 'Conferência de bens locados - Saída',
      DEBT_NOTIFICATION: 'Cobrança',
      PHOTOGRAPHY_PLUS_FOTOP: 'Fotografia Plus Fotop',
      PHOTOGRAPHY_PREMIUM_FOTOP: 'Fotografia Premium Fotop',
      INSPECTION_ENTRANCE_GOLD_ONE_OFF: 'Vistoria de Entrada Gold - Avulsa',
      INSPECTION_EXIT_GOLD_ONE_OFF: 'Vistoria de Saída Gold - Avulsa',
      ROUTINE_INSPECTION: 'Vistoria de rotina',
      INGOING_INSPECTION: 'Vistoria inicial',
      OUTGOING_INSPECTION: 'Vistoria final',
      VIRTUAL_TOUR: 'Tour virtual',
      INGOING_INSPECTION_VIRTUAL_TOUR: 'Vistoria inicial + Tour virtual',
      REVISION_INSPECTION: 'Vistoria de revisão',
      MEASURE_AND_CAPTURE: 'Medir e capturar',
      INGOING_APARTMENT_THREE_BEDS: 'Entrada - Apartamentos até 3 quartos',
      INGOING_APARTMENT_FOUR_PLUS_BEDS: 'Entrada - Apartamentos 4 quartos +',
      INGOING_HOUSE_THREE_BEDS: 'Entrada - Casa até 3 quartos',
      INGOING_HOUSE_FOUR_BEDS: 'Entrada - Casa 4 quartos',
      INGOING_HOUSE_FIVE_PLUS_BEDS: 'Entrada - Casa 5 quartos +',
      OUTGOING_APARTMENT_THREE_BEDS: 'Saída - Apartamentos até 3 quartos',
      OUTGOING_APARTMENT_FOUR_PLUS_BEDS: 'Saída - Apartamentos 4 quartos +',
      OUTGOING_HOUSE_THREE_BEDS: 'Saída - Casa até 3 quartos',
      OUTGOING_HOUSE_FOUR_BEDS: 'Saída - Casa 4 quartos',
      OUTGOING_HOUSE_FIVE_PLUS_BEDS: 'Saída - Casa 5 quartos +',
      QUESTIONNAIRE: 'Questionário',
      GONDOLA: 'Gôndola',
      INSPECTION_ENTRANCE_SHORTSTAY: 'Vistoria de entrada - Shortstay',
      INSPECTION_EXIT_SHORTSTAY: 'Vistoria de saída - Shortstay',
      INGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Apartamentos até 3 quartos e Virtual Tour',
      INGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Apartamentos 4 quartos + e Virtual Tour',
      INGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Casa até 3 quartos e Virtual Tour',
      INGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Casa 4 quartos e Virtual Tour',
      INGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Casa 5 quartos + e Virtual Tour',
      OUTGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Apartamentos até 3 quartos e Virtual Tour',
      OUTGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Apartamentos 4 quartos + e Virtual Tour',
      OUTGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Casa até 3 quartos e Virtual Tour',
      OUTGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Casa 4 quartos e Virtual Tour',
      OUTGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Casa 5 quartos + e Virtual Tour',
      HAUSEFUL_ENTRANCE: 'Vistoria de Entrada Hauseful',
      HAUSEFUL_EXIT: 'Vistoria de Saída Hauseful - Com comparação',
      HAUSEFUL_EXIT_WITHOUT_COMPARISON: 'Vistoria de Saída Hauseful - Sem comparação',
      INSPECTION_ABANDONMENT_HAUSEFUL: 'Vistoria de Abandono - Hauseful',
      INSPECTION_GIACOMELLI_ENTRANCE: 'Vistoria Giacomelli - Entrada',
      INSPECTION_GIACOMELLI_EXIT: 'Vistoria Giacomelli - Saída',
      INSPECTION_PRELIMINARY: 'Vistoria Cautelar',
      INSPECTION_PRELIMINARY_TYPE_ONE: 'Vistoria Cautelar - Tipo 1',
      INSPECTION_PRELIMINARY_TYPE_TWO: 'Vistoria Cautelar - Tipo 2',
      INSPECTION_PRELIMINARY_TYPE_THREE: 'Vistoria Cautelar - Tipo 3',
      INSPECTION_ENTRANCE_REDEPLAN: 'Vistoria de Entrada - Redeplan',
      INSPECTION_EXIT_REDEPLAN: 'Vistoria de Saída - Redeplan',
      INSPECTION_INTERMEDIARY_REDEPLAN: 'Vistoria Intermediária - Redeplan',
      INSPECTION_ROUTINE_PLUS_VIRTUAL_TOUR: 'Vistoria de rotina + Virtual Tour',
      INSPECTION_INGOING_STUDIO: 'Vistoria de Entrada - Studio',
      AIRBNB_CLEANING: 'Limpeza Airbnb',
      HEAVY_CLEANING_POST_CONSTRUCTION: 'Limpeza pesada pós-obra',
      INSPECTION_ENTRANCE_BRASILIA_IMOVEIS: 'Vistoria de Entrada - Brasília Imóveis',
      INSPECTION_EXIT_BRASILIA_IMOVEIS: 'Vistoria de Saída - Brasília Imóveis',
      REINSPECTION_BRASILIA_IMOVEIS: 'Revistoria - Brasília Imóveis',
      INSPECTION_ENTRANCE_NEGRAO: 'Vistoria de Entrada - J. Negrão',
      INSPECTION_EXIT_NEGRAO: 'Vistoria de Saída - J. Negrão',
      REINSPECTION_NEGRAO: 'Revistoria - J. Negrão',
      INSPECTION_ENTRANCE_LIGHT: 'Vistoria de Entrada - Light',
      INSPECTION_EXIT_LIGHT_WITH_COMPARISON: 'Vistoria de saída com comparação - Light',
      INSPECTION_EXIT_LIGHT_WITHOUT_COMPARISON: 'Vistoria de saída sem comparação - Light',
      REINSPECTION_LIGHT: 'Revistoria - Light',
      INSPECTION_ENTRANCE_LAVIERI: 'Vistoria de Entrada - Lavieri',
      INSPECTION_EXIT_LAVIERI: 'Vistoria de Saída - Lavieri',
      REINSPECTION_LAVIERI: 'Revistoria - Lavieri',
      INSPECTION_ENTRANCE_SANTA_ILHA: 'Vistoria de Entrada - Santa Ilha',
      INSPECTION_EXIT_SANTA_ILHA: 'Vistoria de Saída - Santa Ilha',
      REINSPECTION_SANTA_ILHA: 'Revistoria - Santa Ilha',
      INSPECTION_ENTRANCE_DOMINAI: 'Vistoria de Entrada - Dominai',
      INSPECTION_EXIT_DOMINAI: 'Vistoria de Saída - Dominai',
      REINSPECTION_DOMINAI: 'Revistoria - Dominai',
      QUALITY_INSPECTION: 'Vistoria de Qualidade',
      QUALITY_REINSPECTION: 'Revistoria de Qualidade',
      VISIT_CHARLIE: 'Visita - Charlie',
      REPOSSESSION: 'Retomada de posse',
      REGISTRATION_FORM: 'Ficha de cadastro',
      PROPERTY_CAPTURE: 'Captação de imóvel',
      INSPECTION_ENTRANCE_CHARLIE: 'Vistoria de Entrada - Charlie',
      INSPECTION_EXIT_CHARLIE: 'Vistoria de Saída - Charlie',
      REGISTRATION_AUTHORITY_INSPECTION: 'Vistoria de Autoridade de Registro',
      INSPECTION_EXIT_DL_WITH_COMPARISON: 'Vistoria de Saída - com comparação (DL)',
      INSPECTION_PRELIMINARY_ROMA: 'Vistoria Cautelar - Roma',
      INSPECTION_PRELIMINARY_HAUSEFUL: 'Vistoria Cautelar Hauseful',
      INSPECTION_DELIVERY_BUILDER: 'Vistoria de Entrega de Obra - Construtora',
      AGENDA_FORM: 'Ficha de Pauta',
      VISIT_IBAGY: 'Visita - Ibagy',
      VISIT_RENASCENCA: 'Visita - Renascença',
      PROPERTY_CAPTURE_RENASCENCA: 'Captação de Imóveis - Renascença',
      INSPECTION_DELIVERY_STANDARD: 'Vistoria de Entrega de Obra - Standard',
      INSPECTION_DELIVERY_MEDIUM: 'Vistoria de Entrega de Obra - Médio',
      INSPECTION_DELIVERY_HIGH_STANDARD: 'Vistoria de Entrega de Obra - Alto Padrão',
      PREVENTIVE_RECORD: 'Registro Preventivo',
      PREVENTIVE_RECORD_TYPE_ONE: 'Registro Preventivo Tipo 1',
      PREVENTIVE_RECORD_TYPE_TWO: 'Registro Preventivo Tipo 2',
      PREVENTIVE_RECORD_TYPE_THREE: 'Registro Preventivo Tipo 3',
      INSPECTION_ROUTINE_REPORT_PROPERFY: 'Vistoria de Rotina - Properfy',
      INSPECTION_NEUTRAL_MODEL_DOMINAI: 'Modelo Neutro - Dominai',
      undefined: 'Nenhum serviço selecionado',
    },
    history: {
      label: {
        code: 'Código',
        type: 'Serviço',
        realtiesCode: 'Imóveis',
        status: 'Status',
        date: 'Data',
        cancelDate: 'Cancelamento',
        hostName: 'Host',
        appointmentData: 'Dados do Agendamento',
        staus: 'Status',
        additionalAmount: 'Valor Adicional',
        origin: 'Origem',
        observations: 'Observações',
        rescheduleReason: 'Motivo do reagendamento',
        authorData: 'Dados do Autor',
        authorName: 'Nome',
        authorPhone: 'Telefone',
        authorEmail: 'E-mail',
        description: 'Descrição da ação',
        visitorName: 'Nome do inquilino',
        visitorPhone: 'Telefone do inquilino',
        confirmed: 'Confirmado',
        confirmationComment: 'Comentário da confirmação',
        customer: 'Cliente',
        branch: 'Filial',
        attendingToAppointment: 'Comparecerá ao agendamento',
        keysNeedsAuthorization: 'Chaves precisam de autorização',
        additionalData: 'Dados adicionais',
        confirmations: 'Confirmações',
        groupCode: 'Código do grupo',
        group: 'Grupo',
        workerType: 'Tipo',
      },
      action: {
        APPOINTMENT_CREATION: 'Agendamento criado',
        APPOINTMENT_CANCELED_BY_REAL_ESTATE: 'Agendamento cancelado pelo agente',
        APPOINTMENT_CANCELED_BY_CS: 'Agendamento cancelado pelo suporte',
        APPOINTMENT_RESCHEDULED_OPEN: 'Edição de agendamento em aberto',
        APPOINTMENT_RESCHEDULED_SCHEDULED: 'Edição de agendamento confirmado',
        APPOINTMENT_RESCHEDULED_CANCELED: 'Edição de agendamento cancelado',
        APPOINTMENT_ACCEPTED: 'Agendamento aceito',
        APPOINTMENT_STARTED: 'Agendamento iniciado',
        APPOINTMENT_FINISHED: 'Agendamento finalizado',
        APPOINTMENT_CANCELED_BY_HOST_NOT_GOING: 'Agendamento cancelado pelo host',
        APPOINTMENT_CANCELED_BY_SERVICES_NOT_DONE: 'Agendamento cancelado por serviços não realizados',
        APPOINTMENT_DID_NOT_HAPPEN_BY_HOST: 'Agendamento não aconteceu',
        APPOINTMENT_PAYMENT_ON_FINISHED: 'Pagamento do agendamento',
        APPOINTMENT_GENERATED_PAYMENT: 'Pagamento gerado',
        APPOINTMENT_FILES_ADDED: 'Arquivo adicionado',
        APPOINTMENT_FILES_REMOVED: 'Arquivo removido',
        APPOINTMENT_REALTY_ADDED: 'Imóvel adicionado',
        APPOINTMENT_FEEDBACK_BY_REAL_ESTATE: 'Feedback',
        APPOINTMENT_FEEDBACK_BY_VISITOR: 'Feedback do visitante',
        APPOINTMENT_CHARGEBACK: 'Estorno de pagamento',
        APPOINTMENT_CHANGE_HOST: 'Troca de host',
        APPOINTMENT_CHANGE_STATUS: 'Troca de status do agendamento',
        APPOINTMENT_OUTPUT_ADDED: 'Arquivo de resultado de agendamento adicionado',
        APPOINTMENT_OUTPUT_REMOVED: 'Arquivo de resultado de agendamento removido',
        APPOINTMENT_QUOTE_REOPENED: 'Orçamento reaberto',
        APPOINTMENT_CHANGE_DATE: 'Troca de data e hora do agendamento',
        APPOINTMENT_ADDED_TO_GROUP: 'Agendamento adicionado ao grupo',
        APPOINTMENT_REMOVED_FROM_GROUP: 'Agendamento removido do grupo',
        APPOINTMENT_CONFIRMED: 'Agendamento confirmado',
        APPOINTMENT_UPDATE_OBSERVATIONS: 'Alteração de observações',
        APPOINTMENT_CHANGE_KEY_OPTIONS: 'Troca de endereço da chave',
        UPDATE_ADDITIONAL_DATA: 'Alteração de dados adicionais',
        undefined: 'Ação não identificada',
      },
      source: {
        API: 'Api',
        APP: 'App',
        WEB: 'Web',
        SYSTEM: 'Sistema',
      },
    },
    field: {
      status: {
        VS_OPEN: 'Aberto',
        VS_SCHEDULED: 'Agendado',
        VS_DONE: 'Finalizado',
        VS_CANCELED: 'Cancelado',
      },
    },
    formCreate: {
      titles: {
        service: 'Escolha o serviço que deseja agendar',
        serviceAndSubs: 'Escolha o serviço que deseja agendar e a filial',
        dateTime: 'Escolha o dia e horário para realizar o serviço',
        realtiesSingle: 'Escolha um imóvel para a realização do serviço',
        realtiesMultiple: 'Escolha um ou mais imóveis para a realização do serviço',
        realtyTitle: 'Digite o código ou endereço do imóvel',
        keyLocation: 'Informe a localização da chave',
        meetingLocation: 'Informe o local do encontro',
        keyLocationAndMeeting: 'Informe a localização da chave e o local de encontro',
        keyResponsible: 'Responsável pela chave',
        authorization: 'Autorização',
        observation: 'Valor adicional e outras informações',
        realties: 'Imóveis',
        realty: 'Imóvel',
        visitor: 'Dados do visitante',
        tenant: 'Dados do inquilino/acompanhante',
        terminationFileUpload: 'Envie o termo de rescisão',
        terminationFileUploaded: 'Termo enviado com sucesso',
        attachments: 'Anexos',
        attachmentsUploaded: 'Anexos enviados com sucesso',
        appointmentSuccess: 'Agendamento criado com sucesso',
        otherDetails: 'Outros detalhes',
        totalAmount: 'Valor total',
      },
      labels: {
        service: 'Serviço',
        branch: 'Filial',
        realEstate: 'Imobiliária',
        inspector: 'Vistoriador',
        noRealty: 'Nenhum imóvel encontrado',
        branches: 'Filiais',
        displacementAmount: 'Deslocamento',
        attachmentsHint: 'Envie os documentos necessários para a realização deste serviço.',
        fciAmount: 'FCI',
        realties: 'Imóveis',
        others: 'Outros',
        externalCode: 'Cód. externo',
        period: 'Horários com aceite mais rápido',
        date: 'Próximos dias',
        time: 'Melhores horários',
        location: 'Local',
        address: 'Endereço',
        streetNumber: 'Número',
        realtyAddress: 'Endereço do imóvel',
        meetingAddress: 'Local de encontro',
        realEstateAddress: 'Endereço da imobiliária',
        addRealties: 'Adicionar imóveis',
        searchRealty: 'Buscar imóvel',
        baseReport: 'Relatório base',
        baseReportHint: 'Relatório anterior do imóvel usado como referência para a comparação',
        noBaseReport: 'Este imóvel não tem relatório finalizado disponível para comparação. Não é possível agendar este serviço para ele.',
        additionalAmount: 'Valor adicional',
        displacement: 'Deslocamento: {entityName}',
        fci: 'FCI: {entityName}',
        needsAuthorization: 'Necessita autorização para acessar o imóvel?',
        yesNeedsAuthorization: 'Sim',
        noNeedsAuthorization: 'Não',
        keyLocation: 'Local da chave',
        keyPicker: 'Responsável',
        keyAddress: 'Local da chave',
        keyAddressRealty: 'Endereço do imóvel',
        keyAddressRealEstate: 'Endereço do imobiliária',
        searchAddress: 'Buscar endereço',
        addAddress: 'Adicionar endereço',
        updateAddress: 'Atualizar endereço',
        informStreetNumber: 'Informe o número',
        informPostalCode: 'Informe o CEP',
        postalCode: 'CEP',
        visitorName: 'Nome',
        visitorEmail: 'E-mail',
        visitorPhone: 'Telefone',
        visitorDocument: 'CPF/CNPJ',
        visitorBirthDate: 'Nascimento',
        observations: 'Observações',
        summaryKeyPicker: 'Responsável',
        summaryKeyLocation: 'Retirada',
        summaryKeyAddress: 'Endereço',
        noLocationFound: 'Nenhum local encontrado',
        removeRealty: 'Remover imóvel',
        type: 'Tipo do imóvel',
        serviceProviderUser: 'Trabalhador',
        painting: {
          label: 'Pintura',
          new: 'Nova',
          worn: 'Desgastada',
          hostCriteria: 'Crit. do Host',
          host_criteria: 'Crit. do Host',
        },
        trousseau: {
          label: 'Enxoval',
          true: 'Sim',
          false: 'Não',
        },
        furnished: {
          label: 'Mobília',
          true: 'Sim',
          false: 'Não',
        },
        meterage: {
          label: 'Metragem',
          privateArea: 'Área privativa',
          totalArea: 'Área total',
        },
        periods: {
          label: 'Período',
          allDay: 'O dia todo',
          morning: 'Manhã',
          afternoon: 'Tarde',
        },
        endTime: 'horário final',
        to: 'até',
        createRealty: 'Criar imóvel',
        newRealty: 'Novo imóvel',
        uploadText: 'Abaixo você pode anexar arquivos ao agendamento que acabou de criar.',
      },
      hints: {
        meetingAddressHint: 'Único endereço disponível',
        displacement: 'Nossa sugestão é adicionar ao valor do serviço R$ 1,50 por Km rodado',
        fci: 'Fundo de Conservação de Imóvel',
        slotSize: 'O valor será somado ao horário do agendamento, informando o intervalo de tempo que o serviço será realizado (em minutos)',
        minutes: 'minutos',
        visitorEmailReportAccess: 'Para ter acesso ao laudo, o email deve ser preenchido',
      },
      actions: {
        next: 'Próximo',
        previous: 'Anterior',
        save: 'Criar agendamento',
        draft: 'Criar como rascunho',
        createNew: 'Criar novo agendamento',
        confirm: 'Aplicar',
        reschedule: 'Agendar',
        changeHost: 'Trocar Host',
        changeStatus: 'Alterar Status',
      },
      errors: {
        name: 'Digite o nome completo',
        address: 'Endereço incompleto: Adicione mais detalhes ao endereço, como número, bairro, cidade e estado',
        singlePurchaseOrPrepaid: 'Serviços avulsos e pré-pagos devem ser agendados com pelo menos 48 horas de antecedência. entre em contato com o suporte via chat.',
        dateTime: 'Por favor selecione o dia e horário do serviço',
        slotSize: 'Apenas números positivos ou zero são permitidos e menores que 420 minutos.',
        noHostFound: 'Nenhum host encontrado',
        dateTimePeriod: 'Por favor selecione o dia e o período do serviço',
        endTimeRequired: 'Informe o horário final do serviço',
      },
      summary: {
        title: 'Resumo do agendamento',
        branch: 'Filial',
        inspector: 'Vistoriador',
        description: 'Aqui será apresentado o resumo do seu agendamento.',
        serviceAndBranch: 'Serviço e filial',
        dateTime: 'Data e horário',
        realties: 'Imóveis',
        keyLocation: 'Local da chave',
        meetingLocation: 'Local de encontro',
        otherDetails: 'Outros detalhes',
        urgent: 'URGENTE',
        urgencyDescription: 'Atenção: Este serviço foi agendado com prazo inferior a 24 horas de antecedência. Poderá ser aplicada uma taxa adicional de 50% sobre o valor total. Se preferir, você pode escolher uma nova data e horário para evitar a taxa de urgência.',
        period: 'Período',
      },
      calendar: {
        title: 'Próximos agendamentos',
        prev: 'Dias anteriores',
        next: 'Próximos dias',
        oneDay: '1 dia',
        threeDays: '3 dias',
        estimatedEnd: 'Horário final estimado',
        empty: 'Sem agendamentos',
        filters: {
          realty: 'Imóvel',
          host: 'Trabalhador',
          viewMode: 'Visualização',
          groupHosts: 'Hosts',
          groupInternals: 'Internos',
          groupThirdParties: 'Terceiros',
        },
      },
    },
    closeModal: {
      title: 'Confirmação',
      text: 'Ao fechar esta janela, você perderá os todos dados já preenchidos. Deseja fechar a janela?',
      buttons: {
        closeModal: 'Fechar janela',
        cancel: 'Cancelar',
      },
    },
    cancelModal: {
      title: 'Cancelar',
      confirmationQuestion: 'Deseja mesmo cancelar o agendamento?',
      cancelReason: 'Motivo do cancelamento',
      description: 'Descrição',
      cancel: 'Cancelar agendamento',
      code: 'Código',
      type: 'Tipo',
      date: 'Data',
      visitor: 'Visitante',
      meetingLocation: 'Local de encontro',
      notifyPropertyManager: 'Notificar agente imobiliário',
      notifyPropertyManagerInfoMessage: 'Apenas para agendamentos confirmados',
      appointmentsToRemove: 'O(s) seguinte(s) agendamento(s) serão removidos de seu(s) grupo(s):',
      appointmentsToCancel: 'O(s) seguinte(s) agendamento(s) serão cancelados:',
    },
    adminAppointmentReschedule: {
      label: {
        observation: 'Observações',
      },
    },
    adminActions: {
      options: 'Opções',
      reschedule: 'Reagendar',
      showDetails: 'Visualizar',
      removeFromGroup: 'Remover do grupo',
      changeHost: {
        action: 'Trocar Host',
        addHost: 'Adicionar Host',
        selectHost: 'Selecionar host',
        currentHost: 'Host atual',
      },
      changeInspector: {
        action: 'Trocar vistoriador',
        setAction: 'Definir vistoriador',
        selectInspector: 'Selecionar vistoriador',
        currentInspector: 'Vistoriador atual',
        successMessage: 'Vistoriador atualizado com sucesso',
      },
      changeStatus: {
        action: 'Alterar Status',
        selectStatus: 'Selecionar Status',
        openWarningMessage: 'Alterar o status para "{status}" só é possível para agendamentos que estejam "Rascunho", "Agendado", "Cancelado", "Rejeitado" ou "Concluído"',
        scheduledWarningMessage: 'Alterar o status para "{status}" só é possível para agendamentos que estejam "Cancelado" ou "Concluído" e que possuam host',
        draftWarningMessage: 'Alterar o status para "{status}" só é possível para agendamentos que estejam "Aguardando Host" ou "Rejeitado", que não perteçam a um grupo e não possuam host',
        reopenInfoMessage: 'Reabrir devolve a vistoria para o host editar no aplicativo. Quando ele reabrir o relatório, as assinaturas coletadas serão removidas. Os pagamentos do host, se houver, serão estornados.',
      },
      changeType: {
        action: 'Alterar Tipo de Serviço',
        selectType: 'Selecionar Tipo de Serviço',
      },
      changeKeyLocation: {
        action: 'Alterar localização da chave',
        selectKeyLocation: 'Selecionar localização da chave',
        selectRealty: 'Selecionar imóvel',
        selectBranch: 'Selecionar filial',
        newKeyAddress: 'Novo endereço da chave',
        errorMessage: 'Erro ao alterar localização da chave',
      },
      quoteReopen: {
        action: 'Reabrir orçamento',
        successMessage: 'Orçamento reaberto com sucesso',
        errorMessage: 'Erro ao reabrir orçamento',
        warningMessage: 'Atenção, você está prestes a reabrir um orçamento já finalizado.',
      },
      addHost: {
        action: 'Adicionar Host',
        errorMessage: 'Erro ao adicionar Host',
        successMessage: 'Host adicionado com sucesso',
      },
      changeDate: {
        action: 'Alterar data e hora',
        errorMessage: 'Erro ao alterar data e hora do agendamento',
        successMessage: 'Data e hora do agendamento atualizado com sucesso',
        warningMessage: 'Atenção, você está prestes a alterar a data e hora de um agendamento.',
      },
      updateObservations: {
        action: 'Alterar observações',
        successMessage: 'Observações atualizadas com sucesso',
      },
      updateDisplacement: {
        action: 'Alterar adicional',
        successMessage: 'Adicional atualizado com sucesso',
      },
      confirmAppointmentManually: 'Confirmar agendamento manualmente',
      additionalInfo: 'Campos personalizados',
      showConfirmationPage: 'Visualizar página de confirmação',
      sendConfirmationEmail: 'Enviar email de confirmação',
      viewReportFiles: 'Ver arquivos do relatório (S3)',
    },
    details: {
      tabs: {
        details: 'Detalhes',
        history: 'Histórico',
        questionary: 'Questionário',
        reportAndQuotes: 'Relatório e Orçamentos',
        financial: 'Financeiro',
      },
    },
    reschedule: {
      title: 'Reagendar',
      date: 'Data',
      hour: 'Hora',
      byHour: 'Horário exato',
      byPeriod: 'Por período',
      selectPeriod: 'Selecione o período',
      displacement: 'Deslocamento',
      observation: 'Observações',
      rescheduleReason: 'Motivo do reagendamento',
      rescheduleReasonPlaceholder: 'Informe o motivo do reagendamento (opcional)',
      pastDate: 'A data passou',
      cantBeLess: 'Valor não pode ser inferior ao atual {value}',
    },
    visitor: {
      update: 'Atualizar',
      cancel: 'Cancelar',
      updateVisitor: 'Atualizar visitante',
      updateTenant: 'Atualizar inquilino/acompanhante',
      successfullyUpdated: 'Atualizado com sucesso',
      errorWhileUpdating: 'Erro ao atualizar',
    },
    messages: {
      fciUpdated: 'FCI atualizado com sucesso',
      termReplaced: 'Termo substituído com sucesso',
      fciUpdateError: 'Erro ao atualizar FCI',
      cantBeLessThanZero: 'Não pode ser menor que R$ 0,00',
      successfullyCanceled: 'Agendamento cancelado com sucesso',
      addedTags: 'Tags adicionadas com sucesso',
      removedTags: 'Tag removida com sucesso',
      groupCreated: 'Grupo criado com sucesso',
      appointmentNotFound: 'Agendamento não encontrado',
      rescheduled: 'Agendamento reagendado com sucesso',
      updated: 'Agendamento atualizado com sucesso',
    },
    print: {
      realty: 'Imóvel',
      appointment: 'Agendamento',
      host: 'Host',
      visitor: 'Visitante',
      tenant: 'Inquilino/Acompanhante',
      history: 'Histórico',
      doneDate: 'Data de realização',
      questionnaire: 'Questionário',
      questionnaireTitle: 'Questionários do agendamento #{code}',
      questionnaireInfo: '<p class="mb-0">Questionário referente ao agendamento <strong>{code}</strong> {externalCode}.</p>',
      hostInfo: '<p class="mb-0">{host} <br /><small>{hostEmail}</small></p>',
      visitorInfo: '<p class="mb-0">{visitor} <br /><small>{visitorEmail}</small> <br /><small>{visitorPhone}</small></p>',
      noExternalCode: 'Sem código externo',
      externalCode: 'Código externo <strong>{externalCode}</strong>',
    },
    confirmAppointment: {
      title: 'Confirmação de agendamento',
      subtitle: "Este é o formulário de confirmação para uma próxima inspeção domiciliar agendada para o imóvel em que você está, em {appointmentAddress}, código {appointmentCode}. Por favor, verifique a data, hora e outras informações antes de confirmá-lo.",
      options: 'Opções',
      details: 'Detalhes',
      type: 'Tipo',
      scheduledBy: 'Agendado por',
      date: 'Data',
      status: 'Status',
      code: 'Código',
      tenant: 'Inquilino',
      meetingAddress: 'Endereço de encontro',
      agency: 'Agência',
      name: 'Nome',
      between: 'entre',
      at: 'às',
      availableDates: {
        title: 'Escolha um horário para seu agendamento',
        description: 'Selecione uma nova data e hora pro seu agendamento',
        emptyTimes: 'Nenhum horário disponível',
        noAvailableDates: 'Nenhum horário disponível entre {start} e {end}. Por favor, escolha outro horário ou entre em contato com o suporte.',
        selectAnotherDate: 'Mudar data',
        selectedDate: 'Agendada para',
      },
      confirmationData: 'Dados de confirmação',
      sendRejectedEmailModal: {
        title: 'Enviar email de aviso de rejeição',
        unableToSendEmail: 'Não é possível enviar o email de rejeição para o(s) seguinte(s) agendamento(s):',
        unableToSendEmailTip: 'Por favor, note que para enviar o email de rejeição, o agendamento deve estar com o seguinte status: Rejeitado.',
        sendEmailMessage: 'Você está prestes a enviar email(s) de rejeição para {quantity} agendamento(s).',
        sendEmailMessageSingle: 'Você está prestes a enviar email de rejeição para esse agendamento.',
        successfullySent: 'Email(s) de rejeição enviado(s) com sucesso',
        error: 'Ocorreu um erro ao enviar o(s) email(s) de rejeição. Tente novamente mais tarde',
        cancel: 'Cancelar',
        send: 'Enviar',
      },
      sendEmailModal: {
        title: 'Enviar email de confirmação',
        unableToSendEmail: 'Não é possível enviar o email de confirmação para o(s) seguinte(s) agendamento(s):',
        unableToSendEmailTip: 'Por favor, note que para enviar o email de confirmação, o agendamento deve possuir um inquilino atribuído e estar em um dos seguintes status: Aguardando Host, Agendado, Rascunho ou Rejeitado.',
        sendEmailMessage: 'Você está prestes a enviar email(s) de confirmação para {quantity} agendamento(s).',
        sendEmailMessageSingle: 'Você está prestes a enviar email de confirmação para esse agendamento.',
        successfullySent: 'Email(s) de confirmação enviado(s) com sucesso',
        error: 'Ocorreu um erro ao enviar o(s) email(s) de confirmação. Tente novamente mais tarde',
        cancel: 'Cancelar',
        send: 'Enviar',
      },
      rescheduleModal: {
        title: 'Reagendar agendamento',
        cancel: 'Cancelar',
        reschedule: 'Reagendar',
        rescheduleMessage: 'Por favor selecione uma nova data e hora para o agendamento',
        rescheduleWarningMessage: 'Você está prestes a reagendar {quantity} agendamento(s):',
        date: 'Data',
      },
      form: {
        no: 'Não',
        yes: 'Sim',
        name: 'Nome',
        email: 'E-mail',
        tenant: 'Inquilino',
        observation: 'Observações',
        commentExplanation: 'Deixe um comentário descrevendo o motivo por não aceitar o agendamento no campo a baixo.',
        acceptAppointment: 'Aceitar agendamento',
        accept: 'Aceitar',
        notAccept: 'Não aceitar',
        signature: 'Assinatura',
        clearSignature: 'Limpar assinatura',
        confirmAppointment: 'Confirma o agendamento?',
        attendingToAppointment: 'Comparecerá ao agendamento?',
        keysNeedsAuthorization: 'Necessita de autorização para retirada de chaves?',
        signatureExplanation: 'Utilize o cursor do mouse ou o dedo, caso esteja utilizando um celular, para assinar no campo a baixo.',
        keyAccessNotice: 'Por favor, não deixe solicitações de chaves neste formulário. Se for necessário acesso com chaves, envie-nos um e-mail separadamente. O acesso com chaves não está disponível para todas as vistorias e será avaliado caso a caso.',
        acceptQuestion: 'Você aceita assinar o agendamento?',
        submit: 'Enviar',
        term: {
          title: 'Termos e condições:',
          agreeWithTerms: 'Eu reconheço e concedo consentimento para acesso com chaves à nossa propriedade para uma vistoria de rotina.',
          text: '- Propósito: O acesso é para uma vistoria de rotina em nome de {branchName} \n- Data e Hora: O acesso é permitido em {date} \n- Notificação: Recebi o aviso necessário por e-mail \n- Chave: A chave será fornecida por {scheduledBy} (sujeito a disponibilidade) \n- Vistoriador: {inspector}',
        },
        sentAt: 'Enviado em',
        acceptedDate: 'Data combinada',
        answeredAt: 'Respondido em',
      },
      messages: {
        success: 'Enviado com sucesso',
        error: 'Erro ao enviar',
        done: 'Confirmação finalizada com sucesso',
        open: 'Esperando confirmação do host',
        canceled: 'Inspenção cancelada',
        scheduled: 'Inspenção agendada',
        signatureError: 'Erro ao salvar a assinatura, tente novamente',
        invalidStatus: 'Esse link de confirmação já foi utilizado ou expirou',
        adminOrPartnerAnswerConfirmationWarning: 'Você está logado como usuário administrador. Para visualizar a versão do inquilino',
        clickHere: 'clique aqui',
        alreadyConfirmed: 'Essa vistoria já foi confirmada para {datetime}',
        alreadyRejected: 'Essa vistoria já foi recusada',
        morning: '08 horas até as 12 horas',
        afternoon: '12 horas até as 18 horas',
        notAnsweredYet: 'A confirmação ainda não foi respondida',
        noCommentWarning: 'Adicione um comentário para poder rejeitar o agendamento',
        notAttendingOrKeysWarning: 'Para confirmar o agendamento, por favor compareça pessoalmente ou autorize a retirada das chaves',
        notAttendingWarning: 'Para confirmar o agendamento, por favor compareça pessoalmente',
      },
    },
    group: {
      button: {
        create: 'Criar grupo',
      },
      message: {
        createTip: 'Para criar um grupo, selecione agendamentos com status: Aguardando Host, Rejeitado, Rascunho ou Aguardando confirmação',
      },
      hostModal: {
        currentHost: 'Host atual',
        changeHost: 'Alterar host',
        addHost: 'Adicionar host',
        removeHost: 'Remover host',
        changeHostWarningMessage: 'O host selecionado deve ser diferente do atual',
        host: 'Host',
        removeHostWarningMessage: 'Você tem certeza que deseja remover o host do grupo?',
        confirm: 'Confirmar',
      },
    },
    additionalData: {
      modalTitle: 'Campos customizados',
      fields: 'Campos',
      type: 'Tipo',
      title: 'Título',
      value: 'Valor',
      edit: 'Editar',
      remove: 'Remover',
      add: 'Adicionar campo',
      noAdditionalData: 'Nenhum campo personalizado',
      types: {
        PHONE: 'Telefone',
        OTHER: 'Outro',
        LINK: 'Link',
        EMAIL: 'Email',
      },
      modal: {
        title: 'Campos personalizados',
        cancel: 'Cancelar',
        submit: 'Enviar campos personalizados',
        confirm: 'Confirmar',
        confirmToClose: 'Tem certeza que deseja fechar sem salvar as alterações?',
        confirmToCloseTitle: 'Confirmação',
      },
      errors: {
        fillAllFields: 'Preencha todos os campos',
      },
    },
    changeStatusModal: {
      title: 'Alterar status',
      change: 'Alterar',
      cancel: 'Cancelar',
      unableToChangeStatus: 'Não é possível alterar o(s) status do(s) seguinte(s) agendamento(s):',
      changeStatusMessage: 'Você está prestes a alterar o status de {quantity} agendamento(s).',
      successfullyChanged: 'Status do(s) agendamento(s) alterado(s) com sucesso',
      error: 'Ocorreu um erro ao alterar o(s) status do(s) agendamento(s). Tente novamente mais tarde',
    },
    workerType: {
      HOST: 'Host da Hauseful',
      INTERNAL: 'Equipe interna',
      THIRD_PARTY: 'Fornecedores (terceiros)',
    },
  },
  serviceReport: {
    label: {
      serviceReport: 'Relatório de serviço',
      itemName: 'Nome do item',
      itemDescription: 'Descrição do item',
      quantity: 'Quantidade',
      serviceDescription: 'Descrição do serviço',
      location: 'Localização',
      category: 'Categoria',
      items: 'Itens',
      quote: 'Orçamento',
      noServiceReport: 'Nenhuma inconformidade reportada neste serviço',
    },
  },
  customer: {
    label: {
      name: 'Nome',
      document: 'CPF/CNPJ',
      actions: 'Ações',
      linked: 'Vinculado',
      notLinked: 'Não vinculado',
      useCustomWorkerType: 'Apenas vistoriadores internos',
      createLink: 'Criar vínculo conta Asaas',
      removeLink: 'Remover vínculo conta Asaas',
      linkCustomer: 'Vincular cliente',
      linkCustomerType: 'Vincular tipo de serviço',
      unlinkCustomerType: 'Desvincular tipo de serviço',
      removeLinkCustomer: 'Remover vínculo',
      linkServiceProvider: 'Vincular prestador de serviço',
      unlinkServiceProvider: 'Desvincular prestador de serviço',
      removeLinkServiceProvider: 'Remover vínculo prestador de serviço',
      selectedCustomer: 'Cliente selecionado',
      selectedAsaasCustomer: 'Cliente ASAAS selecionado',
      selectCustomer: 'Selecionar cliente',
      serviceType: 'Tipo de serviço',
      visualizeContracts: 'Ver Contratos',
      newContract: 'Novo Contrato',
      save: 'Salvar',
      code: 'Código',
      linkVendors: 'Vincular Fornecedores',
      vendors: 'Fornecedores',
      edit: 'Editar',
      showBranches: 'Ver filiais',
      addBalance: 'Adicionar saldo',
      details: 'Detalhes do cliente',
      balance: 'Saldo atual',
      monetary: 'Monetário',
      selectAServiceProvider: 'Selecione um prestador de serviço',
      selectedServiceProvider: 'Prestador de serviço selecionado',
      search: 'Buscar',
      selectCustomer: 'Selecionar cliente',
      noData: 'Nenhum resultado. Utilize a busca',
      support: 'Suporte ao cliente',
    },
    create: {
      name: 'Nome',
      cnpj: 'CNPJ',
      document: 'CPF/CNPJ',
      logo: 'Marca',
      city: 'Cidade',
      email: 'E-mail',
      phone: 'Telefone',
      informations: 'Informações',
      sendToNomah: 'Enviar para o Nomah',
      tester: 'Usuário de teste',
      useCustomWorkerType: 'Usa apenas vistoriadores internos',
      appointmentResumeContact: 'E-mail para resultado do agendamento',
      sendEmailConfirmationCopy: 'Enviar cópia do e-mail de confirmação',
      sendEmailToEscort: 'Notificar acompanhantes, visitantes ou inquilinos',
      useCancelationLimit: 'Usa limite de antecedência de cancelamento',
      cancelationLimitHours: 'Tempo limite de cancelamento',
      usesCustomFeedback: 'Usar feedback customizado',
      feedbackURL: 'Url para feedback',
      devolusEnabled: 'Ativar Devolus',
      devolusToken: 'Token Devolus',
      devolusId: 'ID Devolus',
      devolusWebhookUrl: 'Url do webhook Devolus',
      addDefaultContract: 'Aplicar Contrato Padrão',
      subscriptionType: 'Tipos de assinatura',
      services: 'Tipo de Serviços',
      realEstateUser: 'Usuário da imobiliária',
      devolus: 'Devolus',
      cpf: 'CPF',
      hour: 'hora',
      hours: 'horas',
      headquarter: 'Matriz',
      negativeBalanceLimit: 'Limite de saldo negativo',
      disputeCreationDaysLimit: 'Prazo de contestação (dias úteis)',
      disputeCreationDaysLimitHint: 'Deixe vazio para usar o padrão de 11 dias úteis',
      messages: {
        successCreation: 'Cliente criado com sucesso',
        successUpdate: 'Cliente atualizado com sucesso',
      },
      startDate: 'Data de ínicio',
      monthlyCapacity: 'Volume mensal (Capacidade)',
      dailyCapacity: 'Volume diário (Capacidade)',
      dailyCapacityError: 'Volume mensal deve ser maior ou igual a 0',
      valueError: 'Valor mensal deve ser maior ou igual a 0',
      priceCapacityError: 'Preço deve ser maior ou igual a 0',
      priceSquareMeterError: 'Preço por m² deve ser maior ou igual a 0',
      baseSquareMetersSizeError: 'Tamanho base deve ser maior ou igual a 0',
      taxForSquareMeters: 'Taxa por m² deve estar entre 0 e 100%',
      currency: 'Moeda',
      feedback: 'Feedback',
      contract: 'Contrato',
      allowKeyPickup: 'Permitir retirada de chaves',
      allowsPeriodAppointment: 'Permitir agendamentos por período',
      allowsEndTimeAppointment: 'Permitir agendamentos com horário final',
      removePartner: 'Remover parceiro',
      serviceDurationValidationType: {
        label: 'Validação de sobreposição de horários',
        options: {
          default: 'Padrão',
          strictDuration: 'Não permitir sobreposição (considera duração do serviço)',
        },
      },
    },
    branches: {
      label: {
        name: 'Nome',
        address: 'Endereço',
        city: 'Cidade',
        cnpj: 'CNPJ',
        phone: 'Telefone',
        email: 'E-mail',
        resumeContact: 'E-mail para envio de sumário de agendamentos',
        isHeadquarter: 'Matriz',
      },
      hint: {
        headquarterCannotBeDeleted: 'A matriz não pode ser excluída',
        headquarterManagedExternally: 'A matriz é gerenciada pelo Hauseful Checklist e não pode ser editada aqui',
      },
      modals: {
        form: {
          createTitle: 'Criar nova filial',
          updateTitle: 'Editar filial',
        },
        confirmDelete: {
          title: 'Confirm',
          text: 'Tem certeza que deseja excluir a filial?',
          usersMigrateToHeadquarter:
            'Os usuários vinculados a esta filial passarão a pertencer à filial matriz.',
          buttons: {
            cancel: 'Cancelar',
            confirm: 'Confirmar',
          },
        },
      },
      messages: {
        successDelete: 'Filial removida com sucesso',
        successUpdate: 'Filial atualizada com sucesso',
        successCreation: 'Filial criada com sucesso',
      },
      actions: {
        create: 'Nova filial',
        edit: 'Editar',
        delete: 'Deletar',
      },
      sendEmailConfirmationCopy: 'Enviar cópia de emails de confirmação',
    },
  },
  movement: {
    actions: {
      movementExcel: {
        generateExcel: 'Gerar Excel',
        fileName: 'relatorio_extrato',
        generateExcelGroupedByBranch: 'Gerar Excel - agrupado por filial',
        fileNameGroupedByBranch: 'relatorio_extrato_agrupado',
      },
    },
    label: {
      createdAt: 'Criado em',
      description: 'Descrição',
      total: 'Total',
      movement: 'Movimentação',
      appointment: 'Agendamento',
      realtiesQuantity: 'Quantidade de imóveis',
      pricePerRealty: 'Preço por imóvel',
      discount: 'Desconto',
      balance: 'Saldo atual',
      available: 'Disponível',
      committed: 'Comprometido',
      customerBalance: 'Saldo atual do cliente',
      showAppointment: 'Visualizar agendamento',
      movementReport: 'Relatório de extrato',
      movementReportByBranch: 'Relatório de extrato por filial',
      changeBalance: 'Alterar saldo',
      category: 'Categoria',
      reason: 'Motivo',
      customer: 'Cliente',
      comment: 'Comentário',
      rechargeNote: 'Nota da recarga',
    },
    category: {
      REFUND: 'Reembolso',
      RECHARGE: 'Recarga',
      TERMINATION: 'Rescisão',
      TRANSFER: 'Transferência',
      CHARGE: 'Cobranças',
      RENT_OUT: 'Rentout',
      POST_PAID: 'Pós pago',
      EXPENDITURE: 'Consumo',
    },
    reason: {
      DAMAGES_AND_LOSSES: 'Danos e prejuízos',
      MISSING_ACCEPTANCE: 'Falta de aceite',
      CREDIT_ADVANCE: 'Adiantamento de crédito',
      CREDIT_CORRECTION: 'Correção de crédito',
      CREDIT_ADDITION: 'Adição de crédito',
      CONTRACTUAL_PENALTY: 'Multa contratual',
      EXPIRED_BALANCE: 'Saldo expirado',
      BALANCE_TRANSFER_BETWEEN_ACCOUNTS: 'Transferência de saldo entre contas',
      EXPIRED_CHARGE: 'Cobrança vencida',
      RECEIVED_CHARGE: 'Cobrança recebida',
      COMISSION_PAYMENT: 'Pagamento de comissão',
      FCI_PAYMENT: 'Pagamento de FCI',
      APPOINTMENT_DONE: 'Agendamento realizado',
      APPOINTMENT_NOT_DONE: 'Agendamento não realizado',
      RECALCULATION: 'Recalculo',
      BALANCE_PAYMENT: 'Pagamento com saldo',
      PLATFORM_FEE: 'Taxa plataforma',
      SAAS_SUBSCRIPTION: 'Assinatura Saas',
      OVERUSE_FEE: 'Taxa de excedência',
    },
    filters: {
      noData: 'Sem resultados',
      document: 'Documento',
      sort: 'Ordenar',
      period: 'Período',
      selectDate: 'Selecione uma data',
      sortBy: {
        ASC: 'Mais antigos',
        DESC: 'Mais recentes',
      },
      buttons: {
        reset: 'Limpar',
        applyFilters: 'Aplicar filtros',
      },
      datePicker: {
        selectedItems: '2 selecionados',
        more: 'mais...',
      },
    },
    table: {
      loading: 'Carregando... Por favor aguarde',
      noData: 'Sem resultados',
    },
    create: {
      value: 'Valor',
      cancel: 'Cancelar',
      description: 'Descrição',
      modalTitle: 'Adicionar saldo',
      availableBalance: 'Saldo atual',
      confirmButton: 'Confirmar',
      sendTo: 'Enviar para',
      messages: {
        balanceAdded: 'Valor de {value} adicionado com sucesso',
        balanceRemoved: 'Valor de {value} removido com sucesso',
      },
    },
    messages: {
      selectAClientToAccessMovements: 'Selecione um cliente para acessar as movimentações',
      balanceAvailableForUse: 'Saldo disponível para uso',
      valueAlreadyCommittedToOpenAppointments: 'Valor já comprometido para os agendamentos em abertos',
    },
  },
  realty: {
    label: {
      type: 'Tipo',
      code: 'Código',
      city: 'Cidade',
      address: 'Endereço',
      description: 'Descrição',
      externalSource: 'Fonte',
      additionalAddressData: 'Complemento',
      postalCode: 'CEP',
      squareMeters: 'Metros quadrados',
      privateArea: 'Área privativa',
      totalArea: 'Área total',
      gallery: 'Galeria de Fotos',
      place: 'Local',
      meters: 'Metragem',
      photos: 'Fotos',
      trousseau: 'Enxoval',
      furniture: 'Mobília',
      paintingStatus: 'Estado da pintura',
      updateRealty: 'Atualizar imóvel',
      details: 'Detalhes',
      privateAreaMetersShort: 'm² Privativa',
      squareMetersShort: 'm² Total',
      theRealtyContains: 'O imóvel possui:',
      doesNotHavePhotos: 'O imóvel não possui fotos',
      doesNotHaveVideos: 'O imóvel não possui vídeos',
      addClickingBelow: 'Adicione clicando abaixo',
      videoUrl: 'Link do vídeo (YouTube ou Vimeo)',
      addVideo: 'Adicionar',
      videoWithoutTitle: 'Vídeo sem nome',
      videoTitle: 'Nome do vídeo (opcional)',
      unsupportedVideoUrl: 'O link precisa ser do YouTube ou do Vimeo',
    },
    type: {
      APARTMENT: 'Apartamento',
      HOUSE: 'Casa',
      PENTHOUSE: 'Cobertura',
      GARAGE: 'Garagem',
      COMERCIAL: 'Imóveis comerciais',
      KITNET: 'Kitnet',
      LOFT: 'Loft',
      TWO_STORY_HOUSE: 'Sobrado',
      LOT: 'Terreno',
      STUDIO: 'Studio',
    },
    warnings: {
      cityFarFromRealEstate: 'A cidade do imóvel é diferente da sua cidade de operação',
      withoutPrivateArea: 'Informe a área privativa do imóvel para continuar',
      realtyNotAvailable: 'Imóvel não disponível no horário e data escolhidos',
      codeExistsAlready: 'Código já existe, adicione outro',
      furnishedNull: 'Imóvel não possui informações sobre mobília',
      trousseauNull: 'Imóvel não possui informações sobre enxoval',
      paintingNull: 'Imóvel não possui informações sobre o estado da pintura',
      withoutType: 'Imóvel não possui um tipo (apartamento, casa, cobertura, etc...)',
      noRouteFound: 'Rua não encontrada (Obrigatório)',
      noPostalCodeFound: 'CEP não encontrado',
      noStreetNumberFound: 'Número não encontrado',
      noVicinityFound: 'Bairro não identificado',
    },
    success: {
      realtyCreated: 'Imóvel criado com sucesso',
      realtyUpdated: 'Imóvel atualizado com sucesso',
      realtyRemoved: 'Imóvel removido com sucesso',
      realtyDetailsUpdated: 'Detalhes do imóvel atualizados',
    },
    buttons: {
      add: 'Adicionar Imóvel',
      save: 'Salvar',
      selectPhotos: 'Selecionar Fotos',
      reset: 'Limpar',
    },
    filters: {
      noData: 'Sem resultados',
      search: 'Buscar',
      city: 'Cidade',
      buttons: {
        reset: 'Limpar',
        applyFilters: 'Aplicar filtros',
      },
    },
    table: {
      loading: 'Carregando... Por favor aguarde',
      noData: 'Sem resultados',
    },
    toaster: {
      success: {
        updated: 'Imóvel atualizado com sucesso!',
        created: 'Imóvel criado com sucesso!',
      },
    },
    paintingStatus: {
      NEW: 'Nova',
      WORN: 'Desgastada',
      HOST_CRITERIA: 'A critério do Host',
    },
    furnishing: {
      NOT_FURNISHED: 'Não mobiliado',
      SEMI_FURNISHED: 'Semi mobiliado',
      FURNISHED: 'Mobiliado',
    },
    formCreate: {
      titles: {
        details: 'Detalhes',
        location: 'Localização',
        vista: 'Dados da Loft',
      },
      vista: {
        categoria: 'Categoria na Loft',
        categoriaRequired: 'Categoria na Loft *',
        finalidade: 'Finalidade na Loft *',
        situacao: 'Situação na Loft *',
        ocupacao: 'Ocupação na Loft *',
        status: 'Status na Loft *',
      },
      code: 'Código *',
      codePlaceholder: 'Digite um código para o imóvel',
      description: 'Descrição',
      descriptionPlaceholder: 'Digite uma descrição para o imóvel',
      paintingStatus: 'Estado da pintura *',
      paintingStatusPlaceholder: 'Selecione o estado da pintura do imóvel',
      furnished: 'Mobília',
      trousseau: 'Enxoval',
      totalArea: 'Área total *',
      totalAreaPlaceholder: 'Digite a área total do imóvel',
      privateArea: 'Área privativa *',
      privateAreaPlaceholder: 'Digite a área privativa do imóvel',
      addressComplement: 'Complemento',
      realtyType: 'Tipo do imóvel *',
      rentValue: 'Valor de aluguel',
      sellValue: 'Valor de venda',
      realEstate: 'Imobiliária',
    },
    hint: {
      editWarning: 'Modificar estas informações impactará no valor dos agendamentos relacionados',
      codeFromVista: 'Código gerado pela Loft, não editável',
      vistaFields: 'Campos exigidos pela Loft, não existem no Hauseful. São enviados apenas na criação do imóvel.',
      vistaCategoria: 'Opcional: a Loft deriva a categoria pelo tipo do imóvel. Obrigatória para o tipo "Outro".',
      seeOnMaps: 'Ver no maps',
      addressExemple: 'Ex.: R. Abdon Batista, 80 - Centro, Joinville - SC, 89201-010, Brasil',
    },
  },
  realEstateUsers: {
    table: {
      name: 'Nome',
      username: 'E-mail',
      is_tester: 'Teste',
      status: 'Ativo',
      type: 'Tipo',
    },
    label: {
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      details: 'Detalhes',
      branch: 'Filial',
      role: 'Função',
      password: 'Senha',
      address: 'Endereço',
      realEstate: 'Imobiliária',
      loading: 'Carregando...',
      repeatPassword: 'Repetir senha',
      isTester: 'Usuário teste',
      isActive: 'Usuário ativo',
      edit: 'Editar usuário',
      create: 'Criar usuário',
      remove: 'Remover usuário',
      cancel: 'Cancelar',
      newUser: 'Novo usuário',
      cpf: 'CPF',
      rg: 'RG',
    },
    hint: {
      onlyNumbers: 'Somente números',
      deleteUser: 'Deseja remover este usuário',
    },
    isTester: {
      true: 'Usuário teste',
      false: 'Não é usuário teste',
    },
    isActive: {
      true: 'Usuário ativo',
      false: 'Usuário inativo',
    },
    actions: {
      show: 'Visualizar',
      edit: 'Editar',
      exclude: 'Excluir',
    },
  },
  boolean: {
    true: 'Sim',
    false: 'Não',
    undefined: 'Não definido',
  },
  report: {
    types: {
      appointment: 'Relatório de agendamentos',
      appointmentWithQuestionnaire: 'Relatório de agendamentos com informações do questionário',
      appointmentQuantity: 'Relatório de quantidade de agendamentos',
    },
    groupingTypes: {
      day: 'Dia',
      week: 'Semana',
      month: 'Mês',
    },
    dateSorts: {
      scheduled: 'Agendada',
      creation: 'Criação',
    },
    buttons: {
      generate: 'Gerar',
      reset: 'Limpar',
    },
    filters: {
      type: 'Tipo',
      grouping: 'Agrupar',
      groupRealties: 'Agrupar imóveis?',
      date: 'Data',
      period: 'Período',
      noData: 'Sem resultados',
      status: 'Status',
      city: 'Cidade',
      branch: 'Filial',
      datePicker: {
        selectedItems: '2 selecionados',
      },
    },
    toaster: {
      success: {
        created: 'Relatório gerado com sucesso!',
      },
    },
    table: {
      noData: 'Sem resultados',
    },
  },
  city: {
    label: {
      city: 'Cidade',
      cities: 'Cidades',
      status: 'Status',
      name: 'Nome',
      state: 'Estado',
      services: 'Serviços',
      enabled: 'Ativa',
      disabled: 'Desativada',
    },
    hint: {
      search: 'Busque pelo nome da cidade',
    },
    noData: 'Sem resultados. Busque pelo nome da cidade.',
  },
  deleteModal: {
    warning: 'Atenção',
    warningMessage: "Você tem certeza que deseja remover '{entityName}'?",
    wantToUnlink: "Deseja desvincular ",
    buttons: {
      delete: 'Deletar',
      cancel: 'Cancelar',
      deleteFile: 'Excluir arquivo',
      deleteAllFiles: 'Excluir todos os arquivos',
      deleteSelectedFiles: 'Excluir arquivos selecionados',
    },
    toaster: {
      success: {
        deleted: "'{entityName}' deletado(a) com sucesso!",
      },
    },
  },
  inactiveModal: {
    title: 'Inativar',
    warning: 'Esta é uma ação sem volta',
    question: 'Deseja realmente inativar este item?',
    buttons: {
      inactivate: 'Inativar',
      cancel: 'Cancelar',
    },
  },
  defaultContract: {
    useOldContractServices: 'Usar serviços do contrato antigo',
  },
  detailsModal: {
    title: 'Detalhes',
    moreDetails: 'Mais detalhes',
  },
  hostOnboarding: {
    types: {
      REGISTRATION: 'Cadastro',
      COURSE: 'Curso',
      TALK: 'Conversa',
      AGREEMENT: 'Contrato',
      DONE: 'Concluído',
      DISAPPROVED: 'Reprovado',
      TEORIC_TEST: 'Teste teórico',
      TEST_SERVICE: 'Serviço de teste',
    },
    disapproveTypes: {
      BACKGROUND_CHECK_SCORE: 'Pesquisa cadastral ruim',
      ENGAGEMENT: 'Baixo engajamento no processo',
      BEHAVIOR: 'Comportamento inadequado durante o processo',
      COURSE_TIME: 'Não terminou o curso no tempo',
      EQUIPMENT: 'Não comprou os equipamentos necessário',
      AGREEMENT_ASSIGNMENT: 'Não assinou o contrato',
      PERMANENT: 'Permanente',
      OTHER: 'Outro',
    },
    coursePercentage: {
      NOT_STARTED: 'Não começou',
      TWENTY: '20%',
      FORTY: '40%',
      SIXTY: '60%',
      EIGHTY: '80%',
      FINISHED: 'Finalizado',
    },
    label: {
      name: 'Nome',
      description: 'Descrição',
      link: 'Link',
      course: 'Curso',
      progress: 'Progresso',
      feedbacks: 'Comentários',
      attachments: 'Anexos',
    },
    warnings: {
      backgroundCheckNotStarted: 'Verificação de histórico pessoal do Host ainda não foi feita',
      backgroundCheckInProgress: 'Verificação de histórico pessoal do Host está em andamento',
      backgroundCheckBadScore: 'Host está com score menor que o esperado',
    },
    actions: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
  },
  defaultServiceValues: {
    cityAndContractType: 'Cidade e tipo de contrato',
    type: 'Tipo',
    values: 'Valores',
    taxes: 'Taxas',
    defaultServiceValuesDetails: 'Detalhes e valores',
    label: {
      serviceType: 'Tipo de serviço',
      contractType: 'Tipo de contrato',
      contractTypeIsRequired:'Tipo de contrato é obrigatório',
      typeServiceIsRequired:'Tipo de serviço é obrigatório',
      contract: 'Contrato',
      noService: 'Nenhum serviço encontrado',
      city: 'Cidade',
      status: 'Status',
      name: 'Nome do serviço',
      dateCreated: 'Data de criação',
      createdBy: 'Criador',
      price: 'Preço',
      discount: 'Desconto',
      squareMetersPrice: 'Preço por m²',
      baseSquareMetersPrice: 'Tamanho base m²',
      taxHost: 'Taxa Host',
      displacementTax: 'Taxa de deslocamento',
      taxSquareMeters: 'Taxa por m²',
      furnitureTax: 'Taxa de mobília',
      semiFurnitureTax: 'Taxa de semimobiliado',
      houseTax: 'Taxa de casa',
      trousseauTax: 'Taxa de enxoval',
      active: 'Ativo',
      inactive: 'Inativo',
      actions: 'Ações',
      hostRealtyFeatureTax: 'Taxas do host sobre valores de características do imóvel',
      urgencyTax: 'Taxa de urgência',
      hostUrgencyTax: 'Taxa do Host sob urgência',
      urgencyHoursLimit: 'Limite de urgência (horas)',
    },
    hints: {
      cityAndContractType: 'Escolha o tipo de contrato e a cidade. Se nenhuma cidade for selecionada, os valores serão adicionados como padrão para todas as cidades.',
    },
    filters: {
      paymentType: 'Tipo de pagamento',
    },
    isActive: {
      true: 'Pagamento ativo',
      false: 'Pagamento inativo',
    },
    actions: {
      add: 'Adicionar',
      create: 'Criar novo valor padrão',
      cancel: 'Cancelar',
      update: 'Atualizar',
      inactivate: 'Inativar',
      visualize: 'Visualizar',
      continueWithoutCity: 'Continuar sem cidade',
      continueWithSelectedCity: 'Continuar com a cidade selecionada',
    },
    messages: {
      serviceAlreadySelected: 'Serviço já selecionado',
      successfullyCreated: 'Valor padrão criado com sucesso',
      errorWhileCreating: 'Erro ao criar valor padrão',
    },
  },
  create: {
    integrationRequest: {
      externalSource: 'Fonte',
      apiUrl: 'URL',
      keyCode: 'Chave',
    },
    label: {
      host: 'Novo Host',
      appointment: 'Novo Agendamento',
      realty: 'Novo Imóvel',
      recharge: 'Nova Recarga',
      defaultServiceValues: 'Novo valor padrão',
      addCustomContract: 'Novo contrato',
      mission: 'Nova Missão',
      integration: 'Nova Integração',
      newUser: 'Novo usuário',
      questionnaire: 'Novo questionário',
      transfer: 'Nova transferência',
      customer: 'Novo cliente',
      announcement: 'Novo comunicado',
      customerBranch: 'Nova filial',
    },
    actionMenu: {
      host: 'Host',
      appointment: 'Agendamento',
      realty: 'Imóvel',
      recharge: 'Recarga',
      defaultServiceValues: 'valor padrão',
      mission: 'Nova Missão',
      integration: 'Integração',
      newUser: 'Usuário',
    },
    save: 'Salvar',
    update: 'Atualizar',
    cancel: 'Cancelar',
    refund: 'Estornar pagamento',
    generateSinglePayment: 'Gerar pagamento avulso',
    generateCalculatedPayment: 'Gerar pagamento calculado',
  },
  update: {
    integrationRequest: {
      externalSource: 'Fonte',
      apiUrl: 'URL',
      keyCode: 'Chave',
    },
  },
  auth: {
    token: 'Token',
    verify: 'Verificar',
    title: 'Somos Hauseful',
    welcome: 'Seja bem-vindo(a). Faça seu login.',
    username: 'Usuário',
    password: 'Senha',
    login: 'Acessar',
    logout: 'Sair do sistema',
    send: 'Enviar e-mail',
    forgotPassword: 'Esqueceu a senha?',
    recoverPassword: 'Recuperar senha',
    update: 'Atualizar senha',
    email: 'E-mail',
    back: 'Voltar',
    resetPassword: 'Redefinir senha',
    goBackToLogin: 'Voltar para o login',
    success: {
      resetPassword: 'Senha redefinida com sucesso',
      recoverPasswordEmailSent: 'E-mail de recuperação de senha enviado',
      recoverPasswordEmailSentDescription: 'Verifique sua caixa de entrada com instruções para redefinir sua senha.',
    },
    errors: {
      recoverTokens: 'Erro ao recuperar tokens',
      retrieveToken: 'Erro ao recuperar tokens',
      requiredToken: 'Token é necessário',
      invalidToken: 'Token inválido',
      login: 'Usuário ou senha inválidos',
      userWithoutRole: 'Nenhuma função foi encontrada para o usuário',
      expiredSession: 'Sua sessão expirou',
      errorGeneratingPdf: 'Erro ao gerar aquivo pdf',
    },
    autoLogin: {
      signingIn: 'Entrando na sua conta…',
    },
  },
  status: {
    OPEN: 'Aguardando Host',
    SCHEDULED: 'Agendado',
    DONE: 'Realizado',
    CANCELED: 'Cancelado',
    PENDING: 'Ações Pendentes',
    DRAFT: 'Rascunho',
    REJECTED: 'Rejeitado',
    PARTNER_OPEN: 'Em aberto',
  },
  type: {
    VISIT: 'Visita',
    VISIT_PREMIUM: 'Visita Premium',
    PHOTOGRAPHY: 'Fotografia',
    PHOTOGRAPHY_PREMIUM: 'Fotografia Premium',
    PHOTOGRAPHY_360: 'Fotografia 360°',
    KEY_DELIVERY: 'Entrega de Chaves',
    INSPECTION: 'Vistoria de Entrada Gold',
    DISPLACEMENT: 'Deslocamento',
    DRONE: 'Drone',
    LOFT_VISIT: 'Visita Loft',
    INSPECTION_ENTRANCE: 'Vistoria de Entrada',
    INSPECTION_ENTRANCE_PREMIUM: 'Vistoria de Entrada Premium',
    INSPECTION_EXIT: 'Vistoria de Saída',
    INSPECTION_EXIT_GOLD: 'Vistoria de Saída Gold',
    INSPECTION_EXIT_PREMIUM: 'Vistoria de Saída Premium',
    INSPECTION_INTERMEDIARY: 'Vistoria Intermediária de Obra',
    INSPECTION_DELIVERY: 'Vistoria de Entrega de Obra',
    INSPECTION_MEASUREMENT: 'Vistoria de Medição',
    INSPECTION_AUDITANCE: 'Auditoria de Vistoria',
    REINSPECTION: 'Revistoria',
    REINSPECTION_HAUSEFUL: 'Revistoria Hauseful',
    TECHNICAL_SKETCH: 'Levantamento 2D Premium',
    TECHNICAL_SKETCH_PLUS: 'Levantamento 2D Plus',
    PLANNING: 'Projetos',
    IMAGE_EDITING: 'Edição de Imagens',
    REALTY_SUGGESTION: 'Sugestão de Imóvel',
    REMOTE_VISIT: 'Visita Remota',
    SKETCH: 'Levantamento 3D',
    INSPECTION_ENTRANCE_PLUS: 'Vistoria de Entrada Plus',
    INSPECTION_EXIT_PLUS: 'Vistoria de Saída Plus',
    INSPECTION_MINI: 'Vistoria Mini de Entrada',
    VISIT_GOLD: 'Visita Gold',
    INSPECTION_CONSTRUCTION_INTERMEDIARY: 'Fiscalização de Obra - Intermediária',
    INSPECTION_CONSTRUCTION_FINAL: 'Fiscalização de Obra - Final',
    INSPECTION_CONFERRING_ENTRANCE: 'Vistoria de Entrada - Conferência',
    INSPECTION_ENTRANCE_HOUSEVIEW: 'Vistoria de Entrada - Houseview',
    INSPECTION_EXIT_HOUSEVIEW: 'Vistoria de Saída - Houseview',
    MAPPING_FOR_EVALUATION: 'Mapeamento de Informações',
    TERMINATION: 'Rescisão',
    RENT_OUT: 'Rescisão Facilitada',
    RENT_OUT_DUDA: 'Rescisão Facilitada - Duda Imóveis',
    DELIVERY: 'Delivery',
    INSPECTION_POST_INSTALLATION: 'Vistoria de Instalações',
    INSPECTION_AND_ESTIMATE: 'Vistoria + Orçamento',
    INSPECTION_SHED: 'Vistoria de Galpão - Entrada',
    INSPECTION_SHED_EXIT: 'Vistoria de Galpão - Saída',
    INSPECTION_IMOBMIX_ENTRANCE: 'Vistoria IMOBMIX de Entrada',
    INSPECTION_IMOBMIX_EXIT: 'Vistoria IMOBMIX de Saída',
    PHOTOGRAPHY_PLUS: 'Fotografia Plus',
    PHOTOGRAPHY_HAUSEFUL: 'Fotografia Hauseful',
    PHOTOGRAPHY_HOME_STAGING: 'Fotografia Gold',
    VISIT_AND_PHOTOS: 'Visita + Fotografia',
    VISIT_LIGHT: 'Visita Light',
    VISIT_SALE: 'Visita de Venda',
    TRAINING: 'Treinamento Prático',
    MISSION: 'Missões',
    PHOTOGRAPHY_PREMIUM_PLUS_360: 'Fotografia Plus + 360',
    OBSERVED_TRAINING: 'Treinamento Observado',
    DUMP: 'Constatação de Abandono',
    EVICTION: 'Visto - Chaves',
    INSPECTION_TEST: 'Vistoria de teste',
    INSPECTION_IB_ENTRANCE: 'Vistoria IB de Entrada',
    INSPECTION_IB_EXIT: 'Vistoria IB de Saída',
    INSPECTION_MINI_EXIT: 'Vistoria Mini de Saída',
    INSPECTION_MINI_EXIT_GOLD: 'Vistoria Mini de Saída Gold',
    INSPECTION_MINI_EXIT_PLUS: 'Vistoria Mini de Saída Plus',
    INSPECTION_MINI_ENTRANCE_GOLD: 'Vistoria Mini de Entrada Gold',
    INSPECTION_MINI_ENTRANCE_PLUS: 'Vistoria Mini de Entrada Plus',
    INSPECTION_ENTRANCE_BACKLOG: 'Vistoria de Entrada - Backlog',
    INSPECTION_EXIT_BACKLOG: 'Vistoria de Saída - Backlog',
    INSPECTION_ENTRANCE_ANTICIPATION: 'Vistoria de Entrada - Antecipação',
    INSPECTION_INSURER: 'Vistoria de Constatação - Seguradoras',
    INSPECTION_ENTRANCE_GOLD_ONE_OFF: 'Vistoria de Entrada Gold - Avulsa',
    INSPECTION_EXIT_GOLD_ONE_OFF: 'Vistoria de Saída Gold - Avulsa',
    LEASED_PROPERTY_CONFERENCE_ENTRANCE: 'Conferência de bens locados - Entrada',
    LEASED_PROPERTY_CONFERENCE_INTERMEDIARY: 'Conferência de bens locados - Intermediária',
    LEASED_PROPERTY_CONFERENCE_EXIT: 'Conferência de bens locados - Saída',
    DEBT_NOTIFICATION: 'Cobrança',
    PHOTOGRAPHY_PLUS_FOTOP: 'Fotografia Plus Fotop',
    PHOTOGRAPHY_PREMIUM_FOTOP: 'Fotografia Premium Fotop',
    ROUTINE_INSPECTION: 'Vistoria de rotina',
    INGOING_INSPECTION: 'Vistoria inicial',
    OUTGOING_INSPECTION: 'Vistoria final',
    VIRTUAL_TOUR: 'Tour virtual',
    INGOING_INSPECTION_VIRTUAL_TOUR: 'Vistoria inicial + Tour virtual',
    REVISION_INSPECTION: 'Vistoria de revisão',
    MEASURE_AND_CAPTURE: 'Medir e capturar',
    INGOING_APARTMENT_THREE_BEDS: 'Entrada - Apartamentos até 3 quartos',
    INGOING_APARTMENT_FOUR_PLUS_BEDS: 'Entrada - Apartamentos 4 quartos +',
    INGOING_HOUSE_THREE_BEDS: 'Entrada - Casa até 3 quartos',
    INGOING_HOUSE_FOUR_BEDS: 'Entrada - Casa 4 quartos',
    INGOING_HOUSE_FIVE_PLUS_BEDS: 'Entrada - Casa 5 quartos +',
    OUTGOING_APARTMENT_THREE_BEDS: 'Saída - Apartamentos até 3 quartos',
    OUTGOING_APARTMENT_FOUR_PLUS_BEDS: 'Saída - Apartamentos 4 quartos +',
    OUTGOING_HOUSE_THREE_BEDS: 'Saída - Casa até 3 quartos',
    OUTGOING_HOUSE_FOUR_BEDS: 'Saída - Casa 4 quartos',
    OUTGOING_HOUSE_FIVE_PLUS_BEDS: 'Saída - Casa 5 quartos +',
    QUESTIONNAIRE: 'Questionário',
    GONDOLA: 'Gôndola',
    INSPECTION_ENTRANCE_SHORTSTAY: 'Vistoria de entrada - Shortstay',
    INSPECTION_EXIT_SHORTSTAY: 'Vistoria de saída - Shortstay',
    INGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Apartamentos até 3 quartos e Virtual Tour',
    INGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Apartamentos 4 quartos + e Virtual Tour',
    INGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Casa até 3 quartos e Virtual Tour',
    INGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Casa 4 quartos e Virtual Tour',
    INGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR:'Entrada - Casa 5 quartos + e Virtual Tour',
    OUTGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Apartamentos até 3 quartos e Virtual Tour',
    OUTGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Apartamentos 4 quartos + e Virtual Tour',
    OUTGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Casa até 3 quartos e Virtual Tour',
    OUTGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Casa 4 quartos e Virtual Tour',
    OUTGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR:'Saída - Casa 5 quartos + e Virtual Tour',
    HAUSEFUL_ENTRANCE: 'Vistoria de Entrada Hauseful',
    HAUSEFUL_EXIT: 'Vistoria de Saída Hauseful - Com comparação',
    HAUSEFUL_EXIT_WITHOUT_COMPARISON: 'Vistoria de Saída Hauseful - Sem comparação',
    INSPECTION_ABANDONMENT_HAUSEFUL: 'Vistoria de Abandono - Hauseful',
    INSPECTION_GIACOMELLI_ENTRANCE: 'Vistoria Giacomelli - Entrada',
    INSPECTION_GIACOMELLI_EXIT: 'Vistoria Giacomelli - Saída',
    INSPECTION_PRELIMINARY: 'Vistoria Cautelar',
    INSPECTION_PRELIMINARY_TYPE_ONE: 'Vistoria Cautelar - Tipo 1',
    INSPECTION_PRELIMINARY_TYPE_TWO: 'Vistoria Cautelar - Tipo 2',
    INSPECTION_PRELIMINARY_TYPE_THREE: 'Vistoria Cautelar - Tipo 3',
    INSPECTION_ENTRANCE_REDEPLAN: 'Vistoria de Entrada - Redeplan',
    INSPECTION_EXIT_REDEPLAN: 'Vistoria de Saída - Redeplan',
    INSPECTION_INTERMEDIARY_REDEPLAN: 'Vistoria Intermediária - Redeplan',
    INSPECTION_ROUTINE_PLUS_VIRTUAL_TOUR: 'Vistoria de rotina + Virtual Tour',
    INSPECTION_INGOING_STUDIO: 'Vistoria de Entrada - Studio',
    AIRBNB_CLEANING: 'Limpeza Airbnb',
    HEAVY_CLEANING_POST_CONSTRUCTION: 'Limpeza pesada pós-obra',
    INSPECTION_ENTRANCE_BRASILIA_IMOVEIS: 'Vistoria de Entrada - Brasília Imóveis',
    INSPECTION_EXIT_BRASILIA_IMOVEIS: 'Vistoria de Saída - Brasília Imóveis',
    REINSPECTION_BRASILIA_IMOVEIS: 'Revistoria - Brasília Imóveis',
    INSPECTION_ENTRANCE_NEGRAO: 'Vistoria de Entrada - J. Negrão',
    INSPECTION_EXIT_NEGRAO: 'Vistoria de Saída - J. Negrão',
    REINSPECTION_NEGRAO: 'Revistoria - J. Negrão',
    INSPECTION_ENTRANCE_LIGHT: 'Vistoria de Entrada - Light',
    INSPECTION_EXIT_LIGHT_WITH_COMPARISON: 'Vistoria de saída com comparação - Light',
    INSPECTION_EXIT_LIGHT_WITHOUT_COMPARISON: 'Vistoria de saída sem comparação - Light',
    REINSPECTION_LIGHT: 'Revistoria - Light',
    INSPECTION_ENTRANCE_LAVIERI: 'Vistoria de Entrada - Lavieri',
    INSPECTION_EXIT_LAVIERI: 'Vistoria de Saída - Lavieri',
    REINSPECTION_LAVIERI: 'Revistoria - Lavieri',
    INSPECTION_ENTRANCE_SANTA_ILHA: 'Vistoria de Entrada - Santa Ilha',
    INSPECTION_EXIT_SANTA_ILHA: 'Vistoria de Saída - Santa Ilha',
    REINSPECTION_SANTA_ILHA: 'Revistoria - Santa Ilha',
    INSPECTION_ENTRANCE_DOMINAI: 'Vistoria de Entrada - Dominai',
    INSPECTION_EXIT_DOMINAI: 'Vistoria de Saída - Dominai',
    REINSPECTION_DOMINAI: 'Revistoria - Dominai',
    QUALITY_INSPECTION: 'Vistoria de Qualidade',
    QUALITY_REINSPECTION: 'Revistoria de Qualidade',
    VISIT_CHARLIE: 'Visita - Charlie',
    REPOSSESSION: 'Retomada de posse',
    REGISTRATION_FORM: 'Ficha de cadastro',
    PROPERTY_CAPTURE: 'Captação de imóvel',
    INSPECTION_ENTRANCE_CHARLIE: 'Vistoria de Entrada - Charlie',
    INSPECTION_EXIT_CHARLIE: 'Vistoria de Saída - Charlie',
    REGISTRATION_AUTHORITY_INSPECTION: 'Vistoria de Autoridade de Registro',
    INSPECTION_EXIT_DL_WITH_COMPARISON: 'Vistoria de Saída - com comparação (DL)',
    INSPECTION_PRELIMINARY_ROMA: 'Vistoria Cautelar - Roma',
    INSPECTION_PRELIMINARY_HAUSEFUL: 'Vistoria Cautelar Hauseful',
    INSPECTION_DELIVERY_BUILDER: 'Vistoria de Entrega de Obra - Construtora',
    AGENDA_FORM: 'Ficha de Pauta',
    VISIT_IBAGY: 'Visita - Ibagy',
    VISIT_RENASCENCA: 'Visita - Renascença',
    PROPERTY_CAPTURE_RENASCENCA: 'Captação de Imóveis - Renascença',
    INSPECTION_DELIVERY_STANDARD: 'Vistoria de Entrega de Obra - Standard',
    INSPECTION_DELIVERY_MEDIUM: 'Vistoria de Entrega de Obra - Médio',
    INSPECTION_DELIVERY_HIGH_STANDARD: 'Vistoria de Entrega de Obra - Alto Padrão',
    PREVENTIVE_RECORD: 'Registro Preventivo',
    PREVENTIVE_RECORD_TYPE_ONE: 'Registro Preventivo Tipo 1',
    PREVENTIVE_RECORD_TYPE_TWO: 'Registro Preventivo Tipo 2',
    PREVENTIVE_RECORD_TYPE_THREE: 'Registro Preventivo Tipo 3',
    INSPECTION_ROUTINE_REPORT_PROPERFY: 'Vistoria de Rotina - Properfy',
    INSPECTION_NEUTRAL_MODEL_DOMINAI: 'Modelo Neutro - Dominai',
  },
  paymentTypes: {
    TRIAL: 'Trial',
    PREPAID: 'Pré-pago',
    PREPAID_SAAS: 'Pré-pago SAAS',
    POSTPAID: 'Pós pago',
    POSTPAID_SAAS: 'Pós pago SAAS',
    SINGLE_PURCHASE: 'Avulsa',
    SUBSCRIPTION_YEAR: 'Anual',
    SUBSCRIPTION_TRIMESTER: 'Trimestral',
    SUBSCRIPTION_SEMESTER: 'Semestral',
    SUBSCRIPTION_NONAMESTER: '9 meses',
    SUBSCRIPTION_LIFELONG: 'Vitalício',
  },
  mission: {
    errors: {
      initialDateAfterEndDate: 'Data inicial transcende a data de encerramento',
    },
    confirmPayModal: {
      title: 'Confirmar',
      text: 'Tem certeza que deseja pagar a missão no valor {price} para o host {email}',
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
    },
    label: {
      name: 'Nome',
      description: 'Descrição',
      active: 'Ativa',
      price: 'Prêmio',
      serviceQuantity: 'Qnt. de Serviços',
      tierHost: 'Tier do Host',
      startDate: 'Início',
      endDate: 'Encerramento',
      hour: 'Hora',
      missionDay: 'Dias da missão',
      serviceTypes: 'Tipos de serviços',
      cities: 'Cidades',
      progressCheck: 'Acompanhamento',
      hostEmail: 'E-mail do Host',
      hostName: 'Nome do host',
      missionProgress: 'Progresso da missão',
      updateMission: 'Atualizar Missão',
      serviceCount: 'Serviços feitos',
      successCreation: 'Missão criada com sucesso!',
      successUpdate: 'Missão atualizada com sucesso!',
      paymentSuccess: 'Missão paga com sucesso!',
      paymentId: 'Id do Pagamento',
      actions: 'Ações',
      hosts: 'Hosts',
      createdBy: 'Criado por',
    },
    status: {
      true: 'Missão ativa',
      false: 'Missão inativa',
    },
    filters: {
      active: 'Somente ativas',
      completed: 'Finalizado',
      inProgress: 'Em andamento',
    },
    actions: {
      create: 'Nova missão',
      update: 'Atualizar missão',
      duplicate: 'Duplicar missão',
      details: 'Mostrar detalhes',
      progress: 'Mostrar progresso',
      edit: 'Editar missão',
      pay: 'Pagar',
    },
    messages: {
      created: 'Missão criada com sucesso',
      updated: 'Missão atualizada com sucesso',
      duplicated: 'Missão duplicada com sucesso',
    },
  },
  host: {
    files: {
      title: 'Documentos',
      empty: 'O host ainda não enviou documentos pelo app',
      loadError: 'Não foi possível carregar os documentos do host',
      category: {
        IDENTITY_DOCUMENT: 'Documento de identidade',
        PROOF_OF_ADDRESS: 'Comprovante de residência',
        CRIMINAL_RECORD: 'Antecedentes criminais',
        CERTIFICATE: 'Certificado',
        OTHER: 'Outros',
      },
    },
    taxRegime: {
      MEI: 'MEI',
      SIMPLES_NACIONAL: 'Simples Nacional',
      LUCRO_PRESUMIDO: 'Lucro presumido',
      LUCRO_REAL: 'Lucro real',
    },
    titles: {
      status: 'Status',
      hostInfo: 'Informações do Host',
      billingData: 'Dados de faturamento',
    },
    status: {
      ACTIVE: 'Ativo',
      BLOCKED: 'Bloqueado',
      SUSPENDED: 'Suspenso',
    },
    message: {
      successfullyUnlinkedAsaasAccount: 'A conta Asaas foi desvinculada com sucesso!',
      successfullyLinkedAsaasAccount: 'A conta Asaas foi vinculada com sucesso!',
      specialtyDeleteConfirm: 'Tem certeza que deseja excluir a especialidade ?',
      specialtyAlreadyExists: 'Já existe uma especialidade com esse nome.',
      specialtyDeleted: 'Especialidade removida com sucesso!',
      specialtyCreated: 'Especialidade criada com sucesso!',
    },
    label: {
      name: 'Nome',
      password: 'Senha',
      username: 'E-mail',
      phone: 'Telefone',
      cityId: 'Id da cidade',
      city: 'Cidade',
      cpf: 'CPF',
      rg: 'RG',
      partner: 'Parceiro',
      serviceProvider: 'Prestador de serviços',
      linked: 'Vinculado a prestador de serviço',
      transaction: 'Transação',
      serviceType: 'Tipo de serviço',
      tester: 'Host de teste',
      active: 'Ativo',
      blocked: 'Bloqueado',
      suspended: 'Suspenso',
      status: 'Status',
      author: 'Autor',
      date: 'Data',
      type: 'Tipo',
      total: 'Total',
      createdAt: 'Criado em',
      serviceTypes: 'Tipos de serviços',
      onboardingStep: 'Onboarding',
      serviceHistory: 'Histórico de serviços',
      startedOnboardingTrainingAt: 'Teste iniciado em',
      birthDate: 'Data de Nascimento',
      inactivated: 'Inativado',
      isFavorite: 'Favorito',
      isMonitored: 'Monitorado',
      false: 'Não',
      true: 'Sim',
      favorite: 'Adicionar como favorito',
      monitor: 'Ativar monitoramento',
      unfavorite: 'Remover como favorito',
      unmonitor: 'Desativar monitoramento',
      description: 'Descrição',
      generatePassword: 'Gerar senha automaticamente',
      hasPlatformAccess: 'Host tem acesso à plataforma',
      unlinkAsaasAccount: 'Desvincular conta Asaas',
      serviceProviderUser: 'Usuário Prestador de serviços',
      notServiceProviderUser: 'Usuário não é Prestador de serviços',
      linkAsaasAccount: 'Vincular conta Asaas',
      asaasAccount: 'Conta Asaas',
      linkAsaas: 'Vincular Asaas',
      unlinkAsaas: 'Desvincular Asaas',
      action: 'Ação',
      comment: 'Comentário',
      linkChecklist: 'Vincular com app Checklist',
      integration: 'Integrações',
      asaasLinked: 'Conta Asaas vinculada',
      asaasNotLinked: 'Conta Asaas não vinculada',
      checklistLinked: 'Vinculado com o app Checklist',
      checklistNotLinked: 'Não vinculado com o app Checklist',
      checklistAccount: 'Conta Checklist',
      hostSpecialties: 'Especialidade Host',
      createSpecialty: 'Criar Especialidade',
      specialties: 'Especialista',
      newSpecialty: 'Nova Especialidade',
      deleteSpecialties: 'Deletar Especialidades',
      actions: 'Ações',
      confirmDeleteSpecialtyTitle: 'Deseja mesmo remover essa especialidade?',
      delete: 'Deletar',
      customerName: 'Nome da empresa',
      customerCnpj: 'CNPJ da empresa',
      taxRegime: 'Regime tributário',
      typeToSearchHost: 'Digite para buscar hosts',
      asaas: {
        walletId: 'Código da carteira',
        accountStatus: 'Status da conta',
        apiKey: 'Chave da API',
        link: 'Vincular',
        unlink: 'Desvincular',
        unlinkWarning: 'Atenção! Você está prestes a desvincular a conta Asaas de {host}',
        status: {
          APPROVED: 'Aprovada',
          PRE_APPROVED: 'Pré aprovada',
          AWAITING_APPROVAL: 'Aguardando aprovação',
          PENDING: 'Pendente',
          REJECTED: 'Rejeitada',
          REFUSED: 'Recusada',
        }
      },
      payments: {
        types: {
          CALCULATED: 'Calculado',
          CUSTOM: 'Personalizado',
          CHARGEBACK: 'Estorno',
          DETACHED: 'Avulso',
        },
        status: {
          CANCELED: 'Cancelado',
          FAILED: 'Falhou',
          PENDING: 'Pendente',
          PROCESSING: 'Em processamento',
          COMPLETED: 'Completo',
          null: 'Aguardando transferência ',
        },
      },
    },
    controlAccess: {
      title: 'Histórico de controle de acesso',
      platformAccess: 'Acesso à plataforma',
      hostHasAccess: 'Host tem acesso a plataforma',
      hostHasNoAccess: 'Host não tem acesso a plataforma',
      blockAccess: 'Bloquear acesso à plataforma',
      unblockAccess: 'Liberar acesso à plataforma',
      servicesAccess: 'Acesso aos serviços',
      hostReceiveServices: 'Host pode receber serviços',
      hostsCantReceiveServices: 'Host não pode receber serviços',
      enableServices: 'Habilitar acesso aos serviços',
      disableServices: 'Desabilitar acesso aos serviços',
      unsuspendBy: 'Desbloqueado por',
      suspendReason: 'Observações sobre a suspensão',
      unsuspendReason: 'Observações sobre a remoção da suspensão',
      observation: 'Observações',
      cancel: 'Cancelar',
      headers: {
        date: 'Data',
        author: 'Autor',
        expiredAt: 'Reativado em',
        action: 'Ação',
      },
      form: {
        reason: 'Motivo',
        observations: 'Observações',
      },
      singlePayment: {
        title: 'Lista de pagamentos',
        createSinglePayment: 'Criar pagamento avulso',
        form: {
          amount: 'Valor do pagamento',
          observations: 'Observações',
        },
      },
      suspensionType: {
        BLOCK: 'Bloqueio',
        SUSPENSION: 'Suspensão',
      },
    },
    suspensionTypes: {
      ADMIN: 'Administrador',
      BEHAVIOUR: 'Comportamento',
      INACTIVITY: 'Inatividade',
      SCORE: 'Nota',
      BLOCK: 'Bloqueado',
      RECYCLE: 'Reciclagem',
      QUITTING: 'Desistência',
      ONBOARDING: 'Onboarding',
      SUSPENSION: 'Suspensão',
    },
    modalUpdate: {
      tabs: {
        info: 'Informações',
        history: 'Histórico',
        serviceHistory: 'Histórico de serviços',
        accessControl: 'Controle de acesso',
        realEstateBlacklist: 'Restrições de Cliente',
        payments: 'Pagamentos',
        singlePayment: 'Pagamentos',
      },
    },
    realEstateBlacklist: {
      title: 'Restrições de Cliente',
      emptyList: 'Nenhuma restrição cadastrada para este host',
      addSuccess: 'Restrição(ões) adicionada(s) com sucesso',
      removeSuccess: 'Restrição removida com sucesso',
      columns: {
        date: 'Data',
        realEstate: 'Imobiliária',
        blockedBy: 'Bloqueado por',
        notes: 'Observações',
        action: 'Ação',
      },
      addForm: {
        realEstateLabel: 'Selecionar Cliente',
        notesLabel: 'Observações (opcional)',
        submitButton: 'Adicionar restrição',
      },
      confirmRemove: {
        title: 'Remover restrição',
        message: 'Tem certeza que deseja remover {name} das restrições deste host?',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        tooltip: 'Remover restrição',
      },
    },
    history: {
      title: 'Histórico de observações',
      addObservation: 'Adicionar observação',
      cancel: 'Cancelar',
      action: {
        PRAISE: 'Elogio',
        COMPLAINT: 'Reclamação',
        NOTE: 'Observação',
        RESTRICTION: 'Restrição',
      },
      error: {
        maxLength: 'Máximo de {maxLength} caracteres',
      }
    },
  },
  payment: {
    transferMethodPreference: {
      PIX: 'PIX',
      ASAAS: 'Asaas',
    },
    list: {
      label: {
        name: 'Nome',
        username: 'E-mail',
        city: 'Cidade',
        total: 'Total',
      },
      actions: {
        hostInvoices: 'Notas fiscais do host',
        createTransfer: 'Gerar transferência',
        appointmentsDoneByHost: 'Serviços realizados pelo host',
        payHost: 'Gerar transferência',
        cancel: 'Cancelar',
        hostPendingInvoicesReport: 'Gerar relatório notas fiscais pendentes',
        downloadNote: 'Baixar notas fiscais',
      },
    },
    type: {
      ASAAS_PIX: 'Pix',
      ASAAS_BOLETO: 'Boleto',
      ASAAS_CREDIT_CARD: 'Cartão',
      VALUELESS: 'F.C.I.',
      BALANCE: 'Saldo',
    },
    label: {
      transferMethod: 'Transferência via',
      pixKeyType: 'Tipo da chave PIX',
      pixKey: 'Chave PIX',
      walletId: 'Carteira',
    },
    pixType: {
      CPF: 'CPF',
      CNPJ: 'CNPJ',
      EMAIL: 'E-mail',
      PHONE: 'Celular',
      EVP: 'Endereço Virtual de Pagamento',
    },
    createTransfer: {
      label: {
        paymentsId: 'Lista de pagamentos',
      },
    },
    messages: {
      transferGenerated: 'Pagamento já em fila para transferência',
    },
    orderBy: {
      ASC: 'A-Z',
      DESC: 'Z-A',
    },
    transferMethods: {
      ASAAS_TRANSFER: 'Conta Asaas',
      BANK_TRANSFER: 'Conta bancária',
    },
    filter: {
      orderBy: 'Ordenação (Nome)',
      transferMethods: 'Tipo de recebimento',
    },
    hint: {
      addToTransferList: 'Selecione para adicionar os itens a lista transferência',
    },
  },
  financial: {
    label: {
      status: 'Status',
      payments: 'Pagamentos',
      serviceDone: 'Serviço realizado?',
    },
    updatePayments: {
      label: {
        createCalculated: 'Gerar Calculado',
        recalculate: 'Recalcular',
        createChargeback: 'Estornar Calculado',
        createSinglePayment: 'Gerar Avulso',
        useOriginalContract: 'Usar contrato original',
      },
      calculated: {
        modalTitle: 'Gerar pagamento calculado',
        markRealty: 'Marque em quais imóveis o serviço foi feito:',
        itemReason: 'Motivo',
        description: 'Descrição',
        changeAdditional: 'Quero redefinir os adicionais',
      },
      chargeback: {
        modalTitle: 'Estornar ultimo pagamento',
      },
      singlePayment: {
        modalTitle: 'Criar Pagamento Avulso',
        value: 'Valor',
        chargeRealEstate: 'Cobrar da imobiliária',
        description: 'Descrição',
        customPaymentTax: 'Taxa do Host',
      },
    },
    payment: {
      label: {
        createdAt: 'Data',
        type: 'Tipo',
        transferStatus: 'Status da transferência',
        value: 'Valor',
        host: 'Host',
        paymentType: {
          CALCULATED: 'Calculado',
          CUSTOM: 'Avulso',
          CHARGEBACK: 'Estorno',
          // only trip reimbursements reach the appointment's list as DETACHED
          DETACHED: 'Reembolso de viagem',
        },
        status: {
          CANCELED: 'Cancelado',
          FAILED: 'Falhou',
          PENDING: 'Pendente',
          PROCESSING: 'Processando',
          COMPLETED: 'Completado',
          waitingForGeneration: 'Aguardando geração',
          awaitingTransfer: 'Aguardando transferência',
          transferred: 'Transferido',
        },
      },
    },
    breakdown: {
      show: 'Ver detalhamento',
      unavailable: 'Detalhamento indisponível para este pagamento',
      realEstate: 'Imobiliária',
      host: 'Host',
      basePrice: 'Valor base',
      discount: 'Desconto',
      area: 'Metragem',
      furniture: 'Mobília',
      semiFurniture: 'Semimobiliado',
      house: 'Casa',
      trousseau: 'Enxoval',
      urgency: 'Urgência',
      total: 'Total',
      additionals: 'Adicionais',
      description: 'Descrição',
      realEstateTotal: 'Total da imobiliária',
      hostTotal: 'Total do host',
      legacySemiFurnished: 'Pagamento calculado antes da separação do semimobiliado: se houver, ele está somado em Mobília.',
    },
    messages: {
      singlePaymentSuccess: 'Pagamento avulso criado com sucesso',
      chargeBackSuccess: 'Pagamento estornado com sucesso',
    },
    emptyState: 'Conteúdo disponível apenas para agendamentos realizados ou cancelados',
  },
  rules: {
    required: 'Obrigatório',
    minValue: 'O valor do campo não pode ser menor que {value}',
    maxValue: 'O valor do campo não pode ser maior que {value}',
    valueRequired: 'Valor deve ser zero ou positivo',
    cancelationLimitHours: 'O tempo máximo para limite de antecedência de cancelamento é 6 horas',
    disputeCreationDaysLimit: 'Informe um prazo entre {min} e {max} dias úteis',
    rg: 'O RG deve conter entre 6 e 14 dígitos',
    cpf: 'O CPF deve conter 11 dígitos',
    password: 'A senha deve conter no mínimo 5 e no máximo 20 dígitos',
    email: 'O e-mail precisa ser válido',
    minAmount: 'O mínimo é {value}',
    maxAmount: 'O limite é {value}',
    cpfInvalid: 'CPF inválido',
    cnpjInvalid: 'CNPJ inválido',
    code: 'Código inválido',
    streetNumber: 'Número inválido',
    phone: 'Telefone inválido',
    phoneRequired: 'O telefone é obrigatório',
    term: 'O termo é obrigatório para Rescisão Facilitada',
    attachment: 'O anexo é obrigatório para este serviço',
    postalCode: 'O CEP é obrigatório',
    length: 'O conteúdo deve ser menor que {length} caracteres',
    cantBeNegative: 'O valor não pode ser negativo',
    cantBeGreaterThan100: 'O valor não pode ser maior que 100',
    cantBeZero: 'Não pode ser zero',
    passwordNeedsToBeTheSame: 'As senhas precisam ser iguais',
    maxCapacity: 'O valor máximo é {value}',
  },
  filters: {
    title: 'Filtros',
    code: 'Código',
    search: 'Buscar',
    select: 'Selecione',
    starred: 'Favoritos',
    monitored: 'Monitoramento',
    dayOfWeek: 'Dia da semana',
    serviceTypes: 'Tipos de serviço',
    serviceType: 'Tipo de serviço',
    myAppointments: 'Meus agendamentos',
    searchByCodeOrAddress: 'Pesquisar por código ou endereço',
    searchByUserOrEmail: 'Pesquisar por nome ou email',
    onlyNotConfirmed: 'Apenas não confirmados',
    dates: 'Datas',
    senders: 'Emissores',
    receivers: 'Destinatários',
    receiver: 'Destinatário',
    host: 'Host',
    hosts: 'Hosts',
    branches: 'Filiais',
    customer: 'Cliente',
    customers: 'Clientes',
    transfer: 'Transferência',
    hasTransfer: 'Possui transferência',
    receiverType: 'Tipo de destinatário',
    subscriptionType: 'Tipo de contrato',
    specialties: 'Especialidade',
    date: {
      recent: 'Recentes',
      startDate: 'Data inicial',
      endDate: 'Data final',
      anyTime: 'A qualquer momento',
      olderThanAWeek: 'Uma semana atrás',
      olderThanAMonth: 'Um mês atrás',
      olderThanSixMonths: 'Há 6 meses atrás',
      olderThanOneYear: 'Há 1 ano atrás',
      customRange: 'Datas específicas',
      singleDate: 'Data',
      to: 'até',
    },
    datePicker: {
      more: 'mais...',
    },
    asc: 'A-Z',
    desc: 'Z-A',
    yes: 'Sim',
    no: 'Não',
    orderBy: 'Ordenar por',
    status: 'Status',
    city: 'Cidade',
    cities: 'Cidades',
    state: 'Estado',
    country: 'País',
    deleted: 'Apagados',
    realEstate: 'Imobiliária',
    searchForRealEstate: 'Buscar por imobiliária',
    searchForAsaasCustomer: 'Buscar por cliente ASAAS',
    hostOnboardingStep: 'Passo Onboarding',
    hostOnboardingCoursePercentage: 'Porcentagem do Curso',
    startedOnboardingTrainingAt: 'Teste iniciado em',
    category: 'Categoria',
    noData: 'Sem resultados',
    realtyCode: 'Código do imóvel',
    userType: 'Tipo de usuário',
    appointmentCode: 'Código do agendamento',
    totalValue: 'Valor total',
    older: 'Mais antigo',
    newer: 'Mais novo',
    appointmentDate: 'Data do agendamento',
    hostName: 'Nome do Host',
  },
  week: {
    MONDAY: 'Segunda',
    TUESDAY: 'Terça',
    WEDNESDAY: 'Quarta',
    THURSDAY: 'Quinta',
    FRIDAY: 'Sexta',
    SATURDAY: 'Sábado',
    SUNDAY: 'Domingo',
  },
  table: {
    noResults: 'Sem resultados',
    noServiceStatus: 'Sem status para apresentar',
    searchText: 'Buscar',
    loading: 'Carregando... Por favor aguarde',
    useTheFiltersToShowData: 'Utilize os filtros para buscar os resultados',
  },
  hostInvoices: {
    firstHalf: 'Primeira quinzena',
    secondHalf: 'Segunda quinzena',
    realEstate: 'Cliente',
    headers: {
      code: 'Cód. Agendamento',
      transactionId: 'Transação',
      createdAt: 'Criado em',
      description: 'Descrição',
      value: 'Valor',
    },
    total: 'Total',
  },
  viewOptions: {
    label: 'Visualização',
    default: 'Padrão',
    compact: 'Compacta',
    list: 'Em lista',
    pendentActions: 'Ações pendentes',
  },
  formLabels: {
    date: 'Data',
    hour: 'Hora',
    code: 'Código',
  },
  upload: {
    label: 'Arraste e solte aqui os arquivos',
    singleLabel: 'Arraste e solte aqui o arquivo',
    or: 'ou',
    select: 'Selecione',
    exclude: 'Excluir',
    photos: 'Fotos',
    videos: 'Vídeos',
    delete: {
      title: 'Esta é uma ação sem volta',
      deleteThis: 'Deseja excluir este arquivo: {value}',
      deleteSelected: 'Deseja excluir o(s) {value} arquivo(s) selecionado(s)?',
      deleteAll: 'Deseja excluir todos os arquivos?',
    },
    success: {
      uploaded: 'Envio realizado com sucesso',
      excluded: 'Arquivo excluído com sucesso',
    },
    error: {
      failed: 'Falha ao enviar o arquivo',
      nameOrExtension: 'Nome do arquivo muito extenso ou arquivo sem extensão',
    },
  },
  currency: {
    symbol: 'R$',
    decimalType: ',00',
  },
  recharge: {
    rechargeList: 'Lista de recargas',
    with: 'Recarregar com',
    select: 'Selecione o',
    rechargeType: 'tipo de recarga',
    cardInformations: 'Informações do cartão',
    otherInformations: 'Outras informações',
    comment: 'Comentário',
    billet: {
      title: 'Boleto Bancário',
      successMessage: 'Boleto gerado com sucesso!',
      warningMessage: 'Atenção, o crédito só estará disponível na plataforma após a compensação do boleto bancário, que pode levar 3 dias úteis',
      download: 'Clique aqui para baixar boleto',
      withBillet: 'Recarregar com boleto',
      billetDownload: 'Baixar boleto',
      billetInfo: 'Informações sobre boletos',
    },
    card: {
      title: 'Cartão de Crédito',
      successMessage: 'Pagamento realizado com sucesso!',
      withCard: 'Recarregar com cartão',
    },
    pix: {
      title: 'PIX',
      withPix: 'Recarregar com PIX',
      payPix: 'Pagar PIX',
      successMessage: 'Pagamento realizado com sucesso!',
      description: 'Use o leitor de seu celular ou copie e cole o código PIX para efetuar o pagamento',
    },
    navigation: {
      goBack: 'Voltar',
    },
    label: {
      code: 'Código',
      type: 'Tipo',
      date_created: 'Data de criação',
      due_date: 'Vencimento',
      real_estate: 'Imobiliária',
      amount: 'Valor',
      status: 'Status',
      attachments: 'Anexos',
      advanced: 'Adiantado',
      notAdvanced: 'Não adiantado',
      advanceBalance: 'Adiantar saldo',
      undoAdvanceBalance: 'Desfazer adiantamento',
      confirmAdvanceBalance: 'Confirmar adiantamento de saldo',
      confirmUndoAdvanceBalance: 'Confirmar desfeita de adiantamento de saldo',
      isAdvancedBalance: 'Saldo adiantado?',
      confirm: 'Confirmar',
      comment: 'Comentário',
    },
    hint: {
      advanceBalanceWarning: 'Atenção! Você está prestes a adiantar o saldo dessa recarga antes do boleto ser compensado. Você está certo disso?',
      undoAdvanceBalanceWarning: 'Atenção! Você está prestes a desfazer o adiantamento de saldo dessa recarga, isso irá gerar uma cobrança negativa ao cliente. Você está certo disso?',
      negativePaymentWarning: 'Os seguintes hosts possuem valores negativos: {hosts}. Tem certeza que deseja continuar com o pagamento?'
    },
    status: {
      PENDING: 'Pendente',
      RECEIVED: 'Recebido',
      CONFIRMED: 'Confirmado',
      OVERDUE: 'Vencido',
    },
    paymentInfo: {
      title: 'Informações sobre pagamentos',
      billet: 'Compensação em até 3 dias úteis',
      credit: 'Compensação logo após a liberação do banco',
      pix: 'Compensação em alguns instantes após o pagamento',
      billetCompleteText: 'Os boletos podem levar até 3 dias úteis para serem compensados, isso varia de banco para banco, e também de acordo com o horário em que foi efetuado. Seus créditos serão adicionados após a compensação do boleto.',
    },
    lowAvailabilityBalance: {
      currentBalance: 'Saldo atual',
      requestMore: 'Solicitar mais créditos',
    },
  },
  question: {
    label: {
      answerOptions: 'Opções de resposta',
      type: 'Tipo',
    },
    type: {
      label: 'Tipo de resposta',
      BOOLEAN: 'Lógica',
      NUMERIC: 'Numérica',
      ENUM: 'Textual múltipla escolha',
      TEXT: 'Textual',
      FILE: 'Arquivo',
    },
    actions: {
      addQuestion: 'Adicionar pergunta',
      editQuestion: 'Editar',
      removeQuestion: 'Deletar',
    },
    modals: {
      confirmDeleteQuestion: {
        title: 'Confirmar',
        text: 'Tem certeza que deseja excluir a pergunta:',
        buttons: {
          cancel: 'Cancelar',
          confirm: 'Confirmar',
        },
      },
    },
    delete: {
      deleteQuestion: {
        successMessage: 'Pergunta deletada com sucesso',
      },
    },
    edit: {
      successMessage: 'Pergunta atualizada com sucesso',
    },
    create: {
      label: 'Pergunta',
      answer: 'Resposta',
      required: 'Obrigatória',
      createAlert: 'Notificar resposta',
      successMessage: 'Pergunta criada com sucesso',
      createButton: 'Salvar pergunta e resposta',
      cancel: 'Cancelar',
      typeSelect: 'Selecione um tipo de pergunta',
      typeSelectPlaceholder:'Digite o endereço',
      minSize: 'Tamanho mínimo',
      zeroForUnlimited: '0 para ilimitado',
      confirmTypeChange: {
        title: 'Confirmar mudança do tipo',
        text: 'Ao alterar o tipo de pergunta as respostas serão apagadas, tem certeza que deseja alterar?',
        buttons: {
          cancel: 'Cancelar',
          confirm: 'Confirmar',
        },
      },
      actions: {
        addAnswer: 'Adicionar resposta de múltipla escolha',
      },
      type: {
        label: 'Tipo de resposta',
        BOOLEAN: 'Lógica',
        NUMERIC: 'Numérica',
        ENUM: 'Textual múltipla escolha',
        TEXT: 'Textual',
        FILE: 'Arquivo',
      },
    },
  },
  questionnaire: {
    label: {
      question: 'Pergunta',
      answer: 'Resposta',
      list: {
        type: 'Tipo',
        name: 'Nome',
        createdAt: 'Criado em',
        published: 'Publicado',
        mustBeSent: 'Deve ser enviado',
      },
      type: {
        DEFAULT: 'Padrão',
        CUSTOM: 'Customizado',
      },
      create: {
        name: 'Nome',
        type: 'Tipo',
        mustBeSent: 'Deve ser enviado',
        title: 'Novo questionário',
        serviceType: 'Tipos de serviço',
      },
      published: {
        true: 'Publicado',
        false: 'Não publicado',
      },
      mustBeSent: {
        true: 'Deve ser enviado',
        false: 'Não deve ser enviado',
      },
      successCreation: 'Questionário criado com sucesso',
      successPublish: 'Questionário publicado com sucesso',
      successUpdate: 'Questionário atualizado com sucesso',
      update: 'Editar questionário',
    },
    actions: {
      goToQuestion: 'Ver perguntas',
      publish: 'Publicar',
      edit: 'Editar',
      print: 'Imprimir',
    },
  },
  roles: {
    ROLE_ADMIN: 'Administrador',
    ROLE_HOST: 'Host',
    ROLE_REAL_ESTATE: 'Imobiliária',
    ROLE_INSPECTOR: 'Inspetor',
    ROLE_REAL_ESTATE_OPERATOR: 'Operador de imobiliária',
    ROLE_SUPPORT: 'Suporte',
    ROLE_HAUSEFUL_FINANCIAL: 'Financeiro Hauseful',
    ROLE_REAL_ESTATE_FINANCIAL: 'Financeiro Imobiliária',
    ROLE_PEOPLE: 'Pessoal Hauseful',
    ROLE_HAUSEFUL_OPERATOR: 'Operador Hauseful',
    ROLE_PARTNER: 'Parceiro Hauseful',
    ROLE_SERVICE_PROVIDER: 'Prestador de Serviços',
    undefined: '---',
  },
  forms: {
    completeName: 'Nome Completo',
    email: 'E-mail',
    cpf: 'CPF',
    document: 'CPF/CNPJ',
    phone: 'Telefone',
    address: 'Endereço',
    addressNumber: 'Número',
    addressComplement: 'Complemento',
    zipCode: 'CEP',
    nameAsCreditCard: 'Nome (como exibido no cartão)',
    creditCardNumber: 'Número do cartão',
    cardDate: 'Data de venc.',
    cardCvv: 'CVC',
    city: 'Cidade',
    countryCode: 'DDI',
    cpfCnpj: 'CPF/CNPJ',
    invalidBirthDate: 'Data de nascimento inválida',
    invalidDateDay: 'O dia parece inválido',
    invalidDateMonth: 'O mês parece inválido',
    invalidDateYear: 'O ano parece inválido',
    citySelect: 'Selecione uma cidade',
    invalidZipCode: 'O CEP parece inválido',
    zipCodeNotFound: 'O CEP parece não pertencer ao endereço',
    expiredMonth: 'Mês de expiração inválido',
    expiredYear: 'Ano de expiração inválido',
    timesGone: 'O horário já passou. Clique na seleção "mais..." e veja outros horários disponíveis',
    dateHint: 'DD/MM/AAAA',
    sending: 'Enviando...',
    loading: 'Carregando...',
    cancel: 'Cancelar',
    save: 'Salvar',
    update: 'Atualizar',
    delete: 'Remover',
    edit: 'Editar',
    confirm: 'Confirmar',
    removeItemMessage: 'Deseja mesmo remover este item?',
    visualize: 'Visualizar',
    createdAt: 'Criado em',
    updatedAt: 'Atualizado em',
    logo: 'Logo',
  },
  myPlan: {
    label: {
      unnamedPlan: 'Plano',
      plan: 'Plano',
      status: 'Situação',
      value: 'Valor',
      installments: '{amount} em {count}x',
      term: 'Vigência',
      nextRenewal: 'Próxima renovação',
      seats: 'Usuários inclusos',
      myCard: 'Meu cartão',
      scheduledChange: 'Seu plano muda para {plan} em {date}. Até lá, nada muda.',
    },
    status: {
      ACTIVE: 'Ativo',
      TRIALING: 'Teste grátis',
      PENDING: 'Aguardando pagamento',
      PAYMENT_FAILED: 'Pagamento recusado',
      EXPIRED: 'Expirado',
      CANCELLED: 'Cancelado',
      NONE: 'Sem assinatura',
    },
    state: {
      notSubscribedTitle: 'Nenhum plano ativo',
      notSubscribedDescription: 'Sua empresa ainda não tem uma assinatura ativa.',
      notReadyTitle: 'Estamos preparando sua conta',
      notReadyDescription: 'Os dados de cobrança ficam disponíveis em alguns instantes.',
      unavailableTitle: 'Não foi possível carregar seu plano',
      unavailableDescription: 'Tente novamente em alguns instantes.',
    },
    action: {
      retry: 'Tentar novamente',
      updateCard: 'Trocar cartão',
    },
    card: {
      title: 'Trocar cartão',
      description: 'O novo cartão substitui o atual nas próximas cobranças. Guardamos apenas a bandeira e os 4 últimos dígitos.',
      confirm: 'Salvar cartão',
      cancel: 'Cancelar',
      success: 'Cartão atualizado.',
      error: {
        CARD_REJECTED: 'Não conseguimos validar esse cartão. Confira os dados ou tente outro.',
        CUSTOMER_DATA_INCOMPLETE: 'Faltam dados de endereço ou telefone no cadastro da sua empresa. Fale com o suporte para concluir.',
        notReady: 'Sua conta ainda está sendo preparada. Tente novamente em alguns instantes.',
        unavailable: 'Não foi possível trocar o cartão agora. Seu cartão atual continua ativo.',
      },
    },
  },
  trial: {
    plan: {
      message: 'Você está em teste grátis até {date}.',
    },
    footer: {
      label: 'Teste grátis',
      endsToday: 'termina hoje',
      oneDayLeft: 'resta 1 dia',
      daysLeft: 'restam {count} dias',
      seePlan: 'Ver meu plano',
    },
  },
  profile: {
    label: {
      edit: 'Editar perfil',
      updatePassword: 'Alterar senha',
      apiToken: 'Token',
      updateRealEstate: 'Editar empresa',
      updateCountry: 'Mudar país',
      updateLanguage: 'Mudar idioma',
      myPlan: 'Meu plano',
    },
    updatePassword: {
      label: {
        currentPassword: 'Senha atual',
        newPassword: 'Senha nova',
        repeatNewPassword: 'Repetir senha nova',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
      },
      messages: {
        passwordsDoNotMatch: 'As senhas não são iguais',
      }
    },
    updateRealEstate: {
      label: {
        webhookUrl: 'URL de callback dos Webhooks',
        useCancelationLimit: 'Usar limite de cancelamento',
        cancelationLimit: 'Limite de cancelamento',
        useExpirationService: 'Usar limite de serviço (horas)',
        expirationHours: 'Limite de serviço (horas)',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        successMessage: 'Dados atualizados com sucesso!',
        allowKeyPickup: 'Permitir retirada de chaves',
        hcheckSyncEnabled: 'Estou utilizando o HCheck (Habilitar Sincronia)',
        showPropertyManagerDataOnConfirmationEmail: 'Mostrar dados do proprietário do imóvel no e-mail de confirmação',
        receiveConfirmationMailCopy: 'Receber cópia de avisos ao inquilino',
        confirmationEmailObservations: 'Observações do e-mail de confirmação',
        disputeCreationDaysLimit: 'Prazo de contestação (dias úteis)',
        disputeCreationDaysLimitHint: 'Deixe vazio para usar o padrão de 11 dias úteis',
      },
    },
  },
  batchSchedule: {
    label: {
      realtyCode: 'Código imóvel',
      date: 'Data',
      code: 'Código',
      type: 'Tipo',
      csvExample: 'Planilha modelo',
      title: 'Agendar via planilha',
      appointments: 'Agendamentos',
      drafts: 'Rascunhos',
      attachment: 'Anexo',
      realEstate: 'Imobiliária',
      branch: 'Filial',
    },
    buttons: {
      schedule: 'Agendar',
      back: 'Voltar',
      ok: 'Ok',
      downloadFile: 'Baixar arquivo',
    },
    message: {
      appointmentsFound: 'Os seguintes agendamentos foram encontrados em sua planilha:',
      explanation: 'Para criar vários {value} de uma só vez baixe a planilha modelo e substitua os dados pelos de seu imóvel.',
      attachmentInfo: 'O anexo selecionado será usado em todos os agendamentos/rascunhos',
      appointmentsNotImported: 'Alguns agendamentos não foram importados devido a erros. Clique no botão abaixo e baixe uma planilha (CSV) contendo apenas os agendamentos com erros.'
    },
    closeModal: {
      title: 'Confirmação',
      message: 'Nem todos os serviços foram agendados. Deseja fechar a janela?',
    },
  },
  partner: {
    filter: {
      orderBy: 'Ordenação (Nome)',
      date: 'Período (Data de criação)',
    },
    label: {
      name: 'Nome',
      description: 'Descrição',
      dateCreated: 'Data de criação',
      asaasWalletId: 'Cód. carteira Asaas',
      historyEmail: 'E-mail para histórico',
      historyEmailHint: 'E-mail onde é enviado cópias dos e-mails enviados para os inquilinos',
      linked: 'Vinculado',
      notLinked: 'Não vinculado',
      asaas: 'Asaas',
    },
    action: {
      save: 'Salvar',
      update: 'Editar parceiro',
      create: 'Criar parceiro',
      cancel: 'Cancelar',
      delete: 'Remover parceiro',
    },
    hints: {
      delete: 'Deseja mesmo remover esse parceiro?',
    },
    noData: 'Sem resultados. Busque pelo nome do parceiro',
  },
  rentOut: {
    status: 'Status',
    complianceAccepted: 'Orçamento aceito',
    complianceNotAccepted: 'Orçamento não aceito',
    noComplianceFound: 'Nenhuma inconformidade encontrada',
    keyWithHost: 'A chave ficou com o host',
    keyWithTenant: 'A chave ficou com o inquilino',
    termWasSent: 'O termo foi enviado',
    termNotSent: 'Termo não enviado',
    tenantDidNotWantToPayOnTime: 'Inquilino não quiz pagar na hora',
    conflictTenantDidNotAgree: 'Inquilino não concorda com o orçamento',
    confirmation: 'Você confirma que incluiu um laudo de entrega de chaves/rescisão válido e que anexou ou colocou links testados para fotos e outros documentos necessários para a execução do serviço?',
    termData: {
      key: 'Chave',
      name: 'Nome',
      signers: 'Signatários',
      signatureDate: 'Data da assinatura',
      termNotSignedYet: 'Assinatura pendente',
      downloadTerm: 'Baixar termo',
    },
    replaceTerm: 'Substituir termo',
    replaceTermWarnMessage: 'Atenção, você está prestes a substituir o termo de rescisão desse agendamento. Essa ação não poderá ser desfeita!',
    newTerm: 'Novo termo',
    waitingPayment: 'Aguardando pagamento',
  },
  keyInfo: {
    NOTHING_TO_EXECUTE_KEYS_DELIVERED: 'Nenhuma inconformidade e chaves entregues.',
    SERVICE_PAID_KEYS_DELIVERED: 'Inquilino aceitou o orçamento e entregou as chaves.',
    SERVICE_NOT_PAID_KEYS_DELIVERED: 'Inquilino quer entregar as chaves mas não aceita pagar na hora.',
    SERVICE_NOT_PAID_KEYS_NOT_DELIVERED: 'inquilino continua com as chaves e vai executar o reparo por conta.',
  },
  appointmentDashboard: {
    label: {
      code: 'Código',
      firstAppointmentDate: '1º agendamento',
      deliverySLA: 'SLA - Entrega',
      firstAcceptanceSLA: 'SLA - 1º aceite',
      firstAppointmentSLA: 'SLA - 1º agendamento',
      deliveryAndFirstAppointmentDifference: 'Diferença SLA',
      acceptanceDate: 'Aceito',
      dateCreated: 'Criação',
      date: 'Data',
      realtyCode: 'Imóvel(is)',
      city: 'Cidade(s)',
      status: 'Status',
      cancelDate: 'Cancelamento',
      cancelReason: 'Motivo',
      lastUpdated: 'Atualizado',
      host: 'Host',
      type: 'Tipo',
      externalCode: 'Código externo',
      tags: 'Tags',

      firstAppointmentDateComp: 'Data primeiro agendamento',
      deliverySLAComp: 'SLA - Entrega',
      firstAcceptanceSLAComp: 'SLA - Primeiro aceite',
      firstAppointmentSLAComp: 'SLA - Primeiro agendamento',
      deliveryAndFirstAppointmentDifferenceComp: 'Diferença SLA (Entrega - Primeiro agendamento)',
      acceptanceDateComp: 'Data do aceite',
      dateCreatedComp: 'Data de criação',
      dateComp: 'Data',
      realtyCodeComp: 'Código do(s) imóvel(is)',
      cancelDateComp: 'Data de cancelamento',
      cancelReasonComp: 'Motivo do cancelamento',
      lastUpdatedComp: 'Data última atualização',
      hostComp: 'Host',
      typeComp: 'Tipo',
      externalCodeComp: 'Código externo',
      tagsComp: 'Tags',
    },
    tag: {
      add: 'Adicionar',
      tags: 'Tags',
      cancel: 'Cancelar',
    },
  },
  cancelRequest: {
    cancelReason: 'Motivo do cancelamento',
  },
  clickToCopy: 'Clique para copiar',
  language: {
    label: 'Idioma',
    location: 'Localização',
    country: 'País',
    currentCountry: 'País atual',
    currentLanguage: 'Idioma atual',
    australia: 'Austrália',
    brazil: 'Brasil',
  },
  userChecklistModal: {
    title: 'Vincular usuário com app Checklist',
    message: `Deseja vincular o usuário '{user}' com o app Checklist?`,
    cancel: 'Cancelar',
    confirm: 'Vincular',
    successfullyCreated: 'Usuário vinculado com sucesso',
    successfullyUpdated: 'Modelo vinculado com sucesso',
    successfullyDeleted: 'Modelo desvinculado com sucesso',
    baseReportRequired: 'Precisa de relatório base?',
    baseReportRequiredInfo: 'Ao agendar este serviço, o cliente escolhe um relatório já finalizado do imóvel, que serve de base para o relatório de comparação.',
    baseReport: 'Relatório base',
    realEstate: 'Imobiliária (opcional)',
    realEstateHint: 'Vazio vincula o modelo padrão do serviço. Com imobiliária, o modelo vale só para ela e substitui o padrão.',
    realEstateColumn: 'Imobiliária',
  },
  dispute: {
    filters: {
      status: 'Status',
      type: 'Tipo',
      owner: 'Atribuído a',
      sla: 'SLA',
      slaBreachedOnly: 'Somente fora do prazo',
      negligence: 'Negligência',
      withNegligence: 'Com negligência',
      withoutNegligence: 'Sem negligência',
    },
    table: {
      headers: {
        code: 'Código',
        realty: 'Imóvel',
        host: 'Host',
        createdAt: 'Criado em',
        status: 'Status',
        items: 'Itens',
        type: 'Tipo',
        owner: 'Atribuído a',
        sla: 'SLA',
      },
      loading: 'Carregando... Por favor aguarde',
      noData: 'Sem resultados',
    },
    status: {
      PENDING: 'Pendente',
      FINISHED: 'Finalizado',
    },
    type: {
      REVIEW: 'Qualidade',
      OBJECTION: 'Contestação',
      AUDIT: 'Auditoria',
    },
    item: {
      status: {
        PENDING: 'Pendentes',
        APPROVED: 'Aprovados',
        REJECTED: 'Rejeitados',
      },
      negligence: 'Negligências',
    },
    ownerType: {
      HAUSEFUL: 'Hauseful',
      CUSTOMER: 'Imobiliária',
      SERVICE_PROVIDER: 'Terceiros',
    },
    sla: {
      remaining: '{duration} restante',
      breached: '{duration} atrasado',
      resolvedIn: 'Resolvido em {duration}',
      hasOverdueItems: 'Possui itens com SLA vencido',
      withinDeadline: 'Todos os itens dentro do prazo',
      finished: 'Contestação finalizada',
    },
  },

  operationTypes: {
    title: 'Tipo de operação',
    serviceOptions: 'Opções do tipo de trabalhador',
    operationTypes: 'Tipos de operação',
    operationType: 'Tipo de operação',
    selectOperationTypes: 'Selecione os tipos de operação',
    selectProfessional: 'Selecione um trabalhador',
    branchSelectedTag: 'Selecionada',
    withoutBranch: 'Sem filial',
    responsibleTeam: 'Time responsável',
    options: {
      host: {
        text: 'Hauseful',
        description: 'Permite que hosts da Hauseful executem os serviços.',
      },
      internal: {
        text: 'Interno',
        description: 'Permite que a equipe interna do cliente execute os serviços.',
      },
      thirdParty: {
        text: 'Fonecedores',
        description: 'Permite que fornecedores (terceiros) executem os serviços.',
      },
    },
    hints: {
      canSelectMultipleOptions: 'Você pode selecionar mais de um tipo de operação.',
      typeToFilterProfessionals: 'Digite para filtrar os profissionais',
      internalDailyServiceLimit: 'Vale apenas para a equipe interna. Hosts da Hauseful e fornecedores seguem no limite de 8.',
    },
    internalDailyServiceLimit: 'Limite de serviços por dia da equipe interna',
    types:{
      HOST: 'Host da Hauseful',
      INTERNAL: 'Equipe interna',
      THIRD_PARTY: 'Fornecedores (terceiros)',
    },
  },
}

const br = Object.assign(brGroup, brInvoices, brCategory, brItem, brPriceTable, brItemPrice, brSplit, brQuote, brVendors, brCharge, brHostRating, brHausefulUsers, brMapDrawing, brImpersonate, brServiceProviders, brFinancialReport, brDivergence)

export default br
